webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(151);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Router = __webpack_require__(177);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	var _useRouterHistory = __webpack_require__(114);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	var _createBrowserHistory = __webpack_require__(144);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _constants = __webpack_require__(18);
	
	var _MediaInspector = __webpack_require__(121);
	
	var _MediaAndAccessoryContainer = __webpack_require__(202);
	
	var _MediaAndAccessoryContainer2 = _interopRequireDefault(_MediaAndAccessoryContainer);
	
	var _Info = __webpack_require__(201);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _App = __webpack_require__(194);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _redux = __webpack_require__(118);
	
	var _reduxThunk = __webpack_require__(190);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRedux = __webpack_require__(110);
	
	var _reducers = __webpack_require__(204);
	
	var _actions = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	function MediaInspectorSelector(state) {
	    var data = state.photoData;
	    return {
	        slug: data.slug,
	        previousSlug: data.previous.slug,
	        nextSlug: data.next.slug,
	        foregroundColor: data.colors[0],
	        backgroundColor: data.colors[1],
	        backgroundImageUri: state.backgroundImageUri,
	        shouldPresentMedia: !(state.mediaQuery === _actions.mediaQueries.XS)
	    };
	}
	var ConnectedMediaInspector = (0, _reactRedux.connect)(MediaInspectorSelector)(_MediaInspector.MediaInspector);
	
	function MediaAndAccessoryContainerSelector(state) {
	    var data = state.photoData;
	    var results = {};
	    if (data) {
	        results.slug = data.slug;
	        results.title = data.title;
	        results.dimensions = data.dimensions;
	        results.previous = data.previous;
	        results.next = data.next;
	        results.isLandscape = data.isLandscape;
	        results.aspectRatio = data.aspectRatio;
	
	        results.foregroundColor = data.colors[0];
	        results.backgroundColor = data.colors[1];
	    }
	    results.didLoadPicturePolyfill = state.didLoadPicturePolyfill;
	    return results;
	}
	var ConnectedMediaAndAccessoryContainer = (0, _reactRedux.connect)(MediaAndAccessoryContainerSelector)(_MediaAndAccessoryContainer2.default);
	
	function InfoSelector(state) {
	    var data = state.photoData;
	    var results = {};
	    if (data) {
	        var date = new Date(data.date);
	        results.slug = data.slug;
	        results.title = data.title;
	        results.location = data.location;
	        results.tags = data.tags;
	        results.weather = data.weatherSummary;
	
	        results.month = _constants.MONTH_NAMES[date.getMonth()];
	        results.year = date.getFullYear();
	        results.foregroundColor = data.colors[0];
	        results.backgroundColor = data.colors[1];
	    }
	    return results;
	}
	var ConnectedInfo = (0, _reactRedux.connect)(InfoSelector)(_Info2.default);
	
	// =================================================================================================
	
	// Don't listen to store by not specifying a selector; only inject dispatch
	var ConnectedApp = (0, _reactRedux.connect)()(_App2.default);
	
	// =================================================================================================
	
	// Create & sync Redux store
	// TODO: inject initialState here instead of in reducers.js
	var store = (0, _redux.createStore)(_reducers.reducer, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	
	var routeConfig = [{
	    path: "/",
	    component: ConnectedApp,
	    onEnter: function onEnter() {
	        if (!store.getState().gridData) {
	            store.dispatch((0, _actions.fetchGridData)());
	        }
	    },
	    childRoutes: [{
	        path: ":slug",
	        component: ConnectedMediaInspector,
	        onEnter: function onEnter(nextState) {
	            var photoData = store.getState().photoData;
	            if (!photoData || photoData.slug !== nextState.params.slug) {
	                store.dispatch((0, _actions.photoDataFromSlugAction)(nextState.params.slug));
	            }
	        },
	        indexRoute: {
	            component: ConnectedMediaAndAccessoryContainer
	        },
	        childRoutes: [{
	            path: "info",
	            component: ConnectedInfo
	        }]
	    }]
	}];
	
	// Create custom history with supports for basename / base href
	// instead of using react-router/lib/browserHistory
	var history = (0, _useRouterHistory2.default)(_createBrowserHistory2.default)();
	_reactDom2.default.render((0, _jsx3.default)(_reactRedux.Provider, {
	    store: store
	}, void 0, (0, _jsx3.default)(_Router2.default, {
	    history: history,
	    routes: routeConfig
	})), document.getElementById("app-root"));

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _for = __webpack_require__(208);
	
	var _for2 = _interopRequireDefault(_for);
	
	var _symbol = __webpack_require__(123);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var REACT_ELEMENT_TYPE = typeof _symbol2.default === "function" && _for2.default && (0, _for2.default)("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(242), __esModule: true };

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(206);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(207);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(205);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// Sass constants are in separate file due to node-sass-json-importer not able to
	// import from JavaScript files; see: https://github.com/Updater/node-sass-json-importer/issues/18
	
	var sassConstants = __webpack_require__(309);
	
	var GOLDEN_RATIO = 1.62,
	    THUMBNAIL_SCALE_NARROW = 100,
	
	// Enlarge thumbnails slightly on larger screens
	THUMBNAIL_SCALE_WIDE = THUMBNAIL_SCALE_NARROW * GOLDEN_RATIO,
	
	// PADDING_BASE = 16,
	// Below max aspect ratios are just estimates, e.g. pano pics could be much wider than 2.39
	MAX_LANDSCAPE_ASPECT_RATIO = 2.39,
	    MAX_PORTRAIT_ASPECT_RATIO = GOLDEN_RATIO,
	
	// 100 * 1.62 = 162
	COLUMN_WIDTH_NARROW = Math.floor(GOLDEN_RATIO * THUMBNAIL_SCALE_NARROW),
	
	// 162 * 1.62 ≈ 262
	COLUMN_WIDTH_WIDE = Math.floor(GOLDEN_RATIO * THUMBNAIL_SCALE_WIDE),
	
	// 262 * 2.39 ≈ 626; used to calculate 2x, 3x, etc.
	MAX_DIMENSION_1X = Math.floor(COLUMN_WIDTH_WIDE * MAX_LANDSCAPE_ASPECT_RATIO);
	
	module.exports = {
	    // Property Info
	    TITLE: "Photography of Ray Shan.",
	    MASTHEAD: {
	        TITLE: "Ray Shan",
	        LINK: "https://shan.io"
	    },
	    AUTHOR: "Ray Shan",
	    COPYRIGHT: "All rights reserved.",
	    BASE_HREF: "/photography/",
	    LINK_DATA: [{ label: "Instagram", uri: "https://instagram.com/rayshan" }, { label: "Twitter", uri: "https://twitter.com/rayshan" }, { label: "Facebook", uri: "https://facebook.com/rayshan" }],
	
	    // Sizing
	    //THUMBNAIL_SCALE_NARROW: THUMBNAIL_SCALE_NARROW,
	    //THUMBNAIL_SCALE_WIDE: THUMBNAIL_SCALE_WIDE,
	    GOLDEN_RATIO: GOLDEN_RATIO,
	    // PADDING_BASE: PADDING_BASE,
	    //MAX_LANDSCAPE_ASPECT_RATIO: MAX_LANDSCAPE_ASPECT_RATIO,
	    MAX_PORTRAIT_ASPECT_RATIO: MAX_PORTRAIT_ASPECT_RATIO,
	    COLUMN_WIDTH_NARROW: COLUMN_WIDTH_NARROW,
	    COLUMN_WIDTH_WIDE: COLUMN_WIDTH_WIDE,
	    MAX_DIMENSION_1X: MAX_DIMENSION_1X,
	
	    // SASS / JavaScript bridge
	    GUTTER: +sassConstants["grid-gutter"].substring(0, 2),
	    cDetailMainLeave: sassConstants["cDetailMainLeave"],
	    cDetailInfoLeave: sassConstants["cDetailInfoLeave"],
	    cDetailMainAppear: sassConstants["cDetailMainAppear"],
	    cDetailInfoAppear: sassConstants["cDetailInfoAppear"],
	    cDetailMainEnter: sassConstants["cDetailMainEnter"],
	    cDetailInfoEnter: sassConstants["cDetailInfoEnter"],
	
	    // Other
	    MONTH_NAMES: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	    KT_TO_KPH: 1.852,
	    CARTIER_DESCRIPTION: "Cartier - Exhibit your best photographs."
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 26 */,
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(35)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(25)
	  , core      = __webpack_require__(19)
	  , ctx       = __webpack_require__(129)
	  , hide      = __webpack_require__(36)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 29 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(49)
	  , IE8_DOM_DEFINE = __webpack_require__(131)
	  , toPrimitive    = __webpack_require__(83)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(132)
	  , defined = __webpack_require__(72);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(30)
	  , createDesc = __webpack_require__(58);
	module.exports = __webpack_require__(27) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(80)('wks')
	  , uid        = __webpack_require__(59)
	  , Symbol     = __webpack_require__(25).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.mediaQueries = exports.SET_BACKGROUND_IMAGE_URI = exports.DID_LOAD_PICTURE_POLYFILL = exports.SET_KEYWORDS = exports.SET_TITLE = exports.FETCH_PHOTO_DATA = exports.FETCH_GRID_DATA = exports.MATCH_MEDIA_QUERY = undefined;
	exports.matchMediaQuery = matchMediaQuery;
	exports.fetchGridData = fetchGridData;
	exports.photoDataFromSlugAction = photoDataFromSlugAction;
	exports.setTitle = setTitle;
	exports.setKeywords = setKeywords;
	exports.loadPicturePolyfill = loadPicturePolyfill;
	exports.setDidLoadPicturePolyfill = setDidLoadPicturePolyfill;
	exports.setBackgroundImageUri = setBackgroundImageUri;
	
	var _data = __webpack_require__(308);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _constants = __webpack_require__(18);
	
	var _fgLoadjs = __webpack_require__(300);
	
	var _fgLoadjs2 = _interopRequireDefault(_fgLoadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var MATCH_MEDIA_QUERY = exports.MATCH_MEDIA_QUERY = "MATCH_MEDIA_QUERY"; // Redux actions
	
	var FETCH_GRID_DATA = exports.FETCH_GRID_DATA = "FETCH_GRID_DATA";
	var FETCH_PHOTO_DATA = exports.FETCH_PHOTO_DATA = "FETCH_PHOTO_DATA";
	var SET_TITLE = exports.SET_TITLE = "SET_TITLE";
	var SET_KEYWORDS = exports.SET_KEYWORDS = "SET_KEYWORDS";
	var DID_LOAD_PICTURE_POLYFILL = exports.DID_LOAD_PICTURE_POLYFILL = "DID_LOAD_PICTURE_POLYFILL";
	var SET_BACKGROUND_IMAGE_URI = exports.SET_BACKGROUND_IMAGE_URI = "SET_BACKGROUND_IMAGE_URI";
	
	// Matches >= pixels, e.g. >= medium-width screen;
	// same as @include media-breakpoint-up(md); see Bootstrap $grid-breakpoints.
	// Some mediaQueries are not directly referenced, e.g. SM / MD.
	// They're still needed to negate other mediaQueries.
	var mediaQueries = exports.mediaQueries = {
	    XS: null,
	    SM: window.matchMedia("(min-width: 544px)"),
	    // Bootstrap uses 768px for MD; increasing slightly so iPad portrait renders as SM
	    // and latest image renders with percentage size
	    MD: window.matchMedia("(min-width: 768px)"),
	    LG: window.matchMedia("(min-width: 992px)")
	};
	
	function matchMediaQuery() {
	    var mediaQuery = void 0;
	    // Order is important; for...in loop does not guarantee order.
	    if (mediaQueries.LG.matches) {
	        mediaQuery = mediaQueries.LG;
	    } else if (mediaQueries.MD.matches) {
	        mediaQuery = mediaQueries.MD;
	    } else if (mediaQueries.SM.matches) {
	        mediaQuery = mediaQueries.SM;
	    } else {
	        // media query would still be mediaQueries.MD but it wouldn't match
	        mediaQuery = mediaQueries.XS;
	    }
	    return {
	        type: MATCH_MEDIA_QUERY,
	        mediaQuery: mediaQuery
	    };
	}
	
	function fetchGridData() {
	    return {
	        type: FETCH_GRID_DATA,
	        data: _data2.default.photoData
	    };
	}
	
	function weatherSummaryFromMETARData(data) {
	    var summary = void 0;
	    var weather = data.weather,
	        clouds = data.clouds,
	        temperature = data.temperature;
	    var _data$wind = data.wind,
	        speed = _data$wind.speed,
	        direction = _data$wind.direction;
	
	    // metar parser produces nested weather.weather
	
	    if (weather) {
	        summary = weather.reduce(function (previous, current) {
	            return current.meaning + (previous ? " / " + previous : "");
	        }, "");
	    } else if (clouds) {
	        summary = clouds.reduce(function (previous, current) {
	            current = current.meaning.includes("no clouds") ? "clear" : current.meaning;
	            return current !== previous ? current + (previous ? " / " + previous : "") : previous;
	        }, "");
	    }
	    return {
	        windSpeed: speed,
	        windDirection: direction,
	        temperature: temperature,
	        summary: summary
	    };
	}
	
	function photoDataFromSlugAction(slug) {
	    var i = void 0;
	    var data = _data2.default.photoData.filter(function (_ref, _i) {
	        var _slug = _ref.slug;
	
	        if (_slug === slug) {
	            i = _i;
	            return true;
	        }
	    })[0];
	
	    if (!data.isProcessed) {
	        data.isLandscape = data.dimensions[0] > data.dimensions[1];
	        data.aspectRatio = data.dimensions[0] / data.dimensions[1];
	        if (data.weather) {
	            data.weatherSummary = weatherSummaryFromMETARData(data.weather);
	        }
	
	        var previousIndex = i === 0 ? _data2.default.photoData.length - 1 : i - 1;
	        var previousData = _data2.default.photoData[previousIndex];
	        if (previousData) {
	            data.previous = {
	                slug: previousData.slug,
	                title: previousData.title
	            };
	        }
	
	        var nextIndex = i === _data2.default.photoData.length - 1 ? 0 : i + 1;
	        var nextData = _data2.default.photoData[nextIndex];
	        if (nextData) {
	            data.next = {
	                slug: nextData.slug,
	                title: nextData.title
	            };
	        }
	
	        data.isProcessed = true;
	    }
	
	    return {
	        type: FETCH_PHOTO_DATA,
	        data: data
	    };
	}
	
	function setTitle() {
	    var titleFragment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    document.title = titleFragment + _constants.TITLE;
	    return {
	        type: SET_TITLE
	    };
	}
	
	function setKeywords() {
	    var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var meta = document.querySelector('meta[name="keywords"]');
	    if (!meta) {
	        meta = document.createElement('meta');
	        meta.name = "keywords";
	        document.getElementsByTagName('head')[0].appendChild(meta);
	    }
	    meta.content = keywords;
	    return {
	        type: SET_KEYWORDS
	    };
	}
	
	/**
	 * This action is invoked once per application.
	 *
	 * @returns {Function}
	 */
	function loadPicturePolyfill() {
	    return function (dispatch) {
	        var picturefillUri = "https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.1/picturefill.min.js";
	        window.picturefillCFG = window.picturefillCFG || [];
	        window.picturefillCFG.push(["algorithm", "saveData"]);
	        (0, _fgLoadjs2.default)(picturefillUri, function () {
	            dispatch(setDidLoadPicturePolyfill(true));
	        });
	    };
	}
	
	function setDidLoadPicturePolyfill(didLoadPicturePolyfill) {
	    return {
	        type: DID_LOAD_PICTURE_POLYFILL,
	        didLoadPicturePolyfill: didLoadPicturePolyfill
	    };
	}
	
	function setBackgroundImageUri(backgroundImageUri) {
	    return {
	        type: SET_BACKGROUND_IMAGE_URI,
	        backgroundImageUri: backgroundImageUri
	    };
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(122);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(50);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(137)
	  , enumBugKeys = __webpack_require__(73);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var StaticComponent = function (_React$Component) {
	    (0, _inherits3.default)(StaticComponent, _React$Component);
	
	    function StaticComponent() {
	        (0, _classCallCheck3.default)(this, StaticComponent);
	        return (0, _possibleConstructorReturn3.default)(this, (StaticComponent.__proto__ || (0, _getPrototypeOf2.default)(StaticComponent)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(StaticComponent, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate() {
	            return false;
	        }
	    }]);
	    return StaticComponent;
	}(_react2.default.Component);
	
	exports.default = StaticComponent;

/***/ },
/* 57 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaPlaceholder = exports.MediaThumbnail = exports.Media = undefined;
	
	var _extends2 = __webpack_require__(48);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(93);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var AbstractMedia = function (_React$Component) {
	    (0, _inherits3.default)(AbstractMedia, _React$Component);
	    (0, _createClass3.default)(AbstractMedia, [{
	        key: "srcWith",
	
	        /**
	         * @param {number} densityFileNameSuffix - this is not the standard srcset pixel density
	         * descriptor as we use media queries to control needed density.
	         * @param {('webp'|'jpeg')} format
	         */
	        value: function srcWith(densityFileNameSuffix, format) {
	            return this.props.basePrefix + "@" + densityFileNameSuffix + "x." + format;
	        }
	        // =============================================================================================
	        // Event Handlers
	        // =============================================================================================
	
	    }, {
	        key: "handleLoad",
	        value: function handleLoad() {
	            // Need to bubble up to GridItem
	            this.setState({ didLoad: true });
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }, {
	        key: "classNameSuffix",
	        get: function get() {
	            return this.state.didLoad ? "c-is-loaded" : "";
	        }
	    }, {
	        key: "onLoadAttribute",
	        get: function get() {
	            return { onLoad: !this.state.didLoad ? this.handleLoad.bind(this) : null };
	        }
	    }]);
	
	    function AbstractMedia() {
	        (0, _classCallCheck3.default)(this, AbstractMedia);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractMedia.__proto__ || (0, _getPrototypeOf2.default)(AbstractMedia)).call(this));
	
	        _this.state = { didLoad: false };
	        return _this;
	    }
	
	    return AbstractMedia;
	}(_react2.default.Component);
	
	var MediaThumbnail = function (_AbstractMedia) {
	    (0, _inherits3.default)(MediaThumbnail, _AbstractMedia);
	
	    function MediaThumbnail() {
	        (0, _classCallCheck3.default)(this, MediaThumbnail);
	        return (0, _possibleConstructorReturn3.default)(this, (MediaThumbnail.__proto__ || (0, _getPrototypeOf2.default)(MediaThumbnail)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MediaThumbnail, [{
	        key: "srcSetFrom",
	        value: function srcSetFrom(format) {
	            return this.srcWith(1, format) + ", " + (this.srcWith(2, format) + " 2x");
	        }
	        /**
	         * Media must be outside of ReactCSSTransitionGroup because
	         * it needs to be in the DOM with MediaPlaceholder for onLoad to fire
	         */
	
	    }, {
	        key: "render",
	        value: function render() {
	            return (0, _jsx3.default)("div", {
	                style: this.style,
	                title: this.props.title,
	                className: "c-media-wrapper"
	            }, void 0, this.media, this.mediaPlaceholder);
	        }
	    }, {
	        key: "mediaPlaceholderProps",
	        get: function get() {
	            var _props = this.props,
	                width = _props.width,
	                aspectRatio = _props.aspectRatio,
	                backgroundColor = _props.backgroundColor,
	                foregroundColor = _props.foregroundColor,
	                title = _props.title;
	
	            return {
	                width: width,
	                aspectRatio: aspectRatio,
	                backgroundColor: backgroundColor,
	                foregroundColor: foregroundColor,
	                key: title + "-mediaPlaceholder"
	            };
	        }
	    }, {
	        key: "mediaPlaceholder",
	        get: function get() {
	            return _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                MediaThumbnail.mediaPlaceholderTransitionProps,
	                !this.state.didLoad ? _react2.default.createElement(MediaPlaceholder, this.mediaPlaceholderProps) : null
	            );
	        }
	    }, {
	        key: "style",
	        get: function get() {
	            var _props2 = this.props,
	                width = _props2.width,
	                aspectRatio = _props2.aspectRatio;
	
	            return {
	                width: width,
	                // Media must have height before onload as it needs to take up space for whole grid
	                // to be laid out correctly before onload.
	                // Cannot rely on MediaLoader's height because MediaLoader is absolutely positioned.
	                // Using padding-top, which is relative to width & forces consistent aspect ratio.
	                paddingTop: this.state.didLoad ? null : 100 / aspectRatio + "%"
	            };
	        }
	    }, {
	        key: "media",
	        get: function get() {
	            return (0, _jsx3.default)("picture", {
	                className: "c-media-thumbnail " + this.classNameSuffix
	            }, void 0, (0, _jsx3.default)("source", {
	                srcSet: this.srcSetFrom("webp"),
	                type: "image/webp"
	            }), _react2.default.createElement("img", (0, _extends3.default)({
	                srcSet: this.srcSetFrom("jpeg")
	                // Fallback for browsers not supporting srcSet
	                , src: this.srcWith(1, "jpeg"),
	                alt: this.props.title
	            }, this.onLoadAttribute)));
	        }
	    }], [{
	        key: "mediaPlaceholderTransitionProps",
	        get: function get() {
	            return {
	                component: "div",
	                // component: FirstChild,
	                className: "c-media-placeholder-wrapper",
	                transitionName: "c-detail-background-fade",
	                // style: {width: this.props.width},
	                transitionAppear: false,
	                transitionEnter: false,
	                transitionLeaveTimeout: 1000
	            };
	        }
	    }]);
	    return MediaThumbnail;
	}(AbstractMedia);
	
	var Media = function (_AbstractMedia2) {
	    (0, _inherits3.default)(Media, _AbstractMedia2);
	
	    function Media() {
	        (0, _classCallCheck3.default)(this, Media);
	        return (0, _possibleConstructorReturn3.default)(this, (Media.__proto__ || (0, _getPrototypeOf2.default)(Media)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Media, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            // return false;
	            return this.state.didLoad !== nextState.didLoad;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            // Container element is necessary for media to have a default size with background color
	            // so page doesn't load with accessories bunched up together.
	            // Not sure why but picture element couldn't act as the container element;
	            // size & background-color don't apply to it.
	            return (0, _jsx3.default)("div", {
	                style: this.style,
	                title: this.props.title,
	                className: "c-media-wrapper"
	            }, void 0, this.media);
	        }
	    }, {
	        key: "mediaQueryList",
	
	        /**
	         * When this media query is matched, we serve the 3x image
	         * landscape: 626 * 2 ≈ 922
	         * portrait: 626 * 2 / 1.6 ≈ 576
	         */
	        get: function get() {
	            var minWidth = Math.floor(this.props.isLandscape ? _constants.MAX_DIMENSION_1X * 2 * 0.9 : _constants.MAX_DIMENSION_1X * 2 / _constants.MAX_PORTRAIT_ASPECT_RATIO);
	            return "(min-width: " + minWidth + "px)";
	        }
	    }, {
	        key: "style",
	        get: function get() {
	            var _props3 = this.props,
	                foregroundColor = _props3.foregroundColor,
	                backgroundColor = _props3.backgroundColor,
	                width = _props3.width,
	                height = _props3.height;
	
	            return !this.state.didLoad ? {
	                width: width,
	                height: height,
	                background: "linear-gradient(56deg, " + backgroundColor + ", " + foregroundColor + ")"
	            } : null;
	        }
	    }, {
	        key: "media",
	        get: function get() {
	            var _this4 = this;
	
	            // console.log(this.mediaQueryList);
	            var densityFileNameSuffixModifier = this.props.suffix === "png" ? 1 : 0;
	            return (0, _jsx3.default)("picture", {
	                className: "media " + this.classNameSuffix,
	                title: this.props.title
	            }, void 0, this.props.suffix !== "png" ? (0, _jsx3.default)("source", {
	                media: this.mediaQueryList,
	                srcSet: this.srcWith(3 - densityFileNameSuffixModifier, "webp"),
	                type: "image/webp"
	            }) : null, this.props.suffix !== "png" ? (0, _jsx3.default)("source", {
	                srcSet: this.srcWith(2 - densityFileNameSuffixModifier, "webp"),
	                type: "image/webp"
	            }) : null, (0, _jsx3.default)("source", {
	                media: this.mediaQueryList,
	                srcSet: this.srcWith(3 - densityFileNameSuffixModifier, this.props.suffix || "jpeg")
	            }), _react2.default.createElement("img", (0, _extends3.default)({
	                src: this.srcWith(2 - densityFileNameSuffixModifier, this.props.suffix || "jpeg"),
	                alt: this.props.title,
	                ref: function ref(element) {
	                    return _this4.img = element;
	                },
	                id: this.props.id,
	                className: "will-dim-on-active"
	            }, this.onLoadAttribute)));
	        }
	    }]);
	    return Media;
	}(AbstractMedia);
	
	/**
	 * Provide either width or aspect ratio via props;
	 * if width isn't provided, will use paddingTop to maintain aspect ratio
	 */
	
	
	var MediaPlaceholder = function (_React$Component2) {
	    (0, _inherits3.default)(MediaPlaceholder, _React$Component2);
	
	    function MediaPlaceholder() {
	        (0, _classCallCheck3.default)(this, MediaPlaceholder);
	        return (0, _possibleConstructorReturn3.default)(this, (MediaPlaceholder.__proto__ || (0, _getPrototypeOf2.default)(MediaPlaceholder)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MediaPlaceholder, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.width !== this.props.width;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props4 = this.props,
	                width = _props4.width,
	                height = _props4.height,
	                aspectRatio = _props4.aspectRatio,
	                foregroundColor = _props4.foregroundColor,
	                backgroundColor = _props4.backgroundColor;
	
	            var style = {
	                width: width,
	                background: "linear-gradient(56deg, " + backgroundColor + ", " + foregroundColor + ")"
	            };
	            if (height) {
	                style.height = height;
	            } else {
	                style.paddingTop = 1 / aspectRatio * 100 + "%";
	            }
	            return (0, _jsx3.default)("div", {
	                className: "c-media-placeholder",
	                style: style
	            });
	        }
	    }]);
	    return MediaPlaceholder;
	}(_react2.default.Component);
	
	// =================================================================================================
	
	exports.Media = Media;
	exports.MediaThumbnail = MediaThumbnail;
	exports.MediaPlaceholder = MediaPlaceholder;

/***/ },
/* 70 */,
/* 71 */,
/* 72 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(49)
	  , dPs         = __webpack_require__(258)
	  , enumBugKeys = __webpack_require__(73)
	  , IE_PROTO    = __webpack_require__(79)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(130)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(251).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 77 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(30).f
	  , has = __webpack_require__(29)
	  , TAG = __webpack_require__(37)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(80)('keys')
	  , uid    = __webpack_require__(59);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 81 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(72);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(50);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(25)
	  , core           = __webpack_require__(19)
	  , LIBRARY        = __webpack_require__(75)
	  , wksExt         = __webpack_require__(85)
	  , defineProperty = __webpack_require__(30).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(37);

/***/ },
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(401);

/***/ },
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var _ref = (0, _jsx3.default)("span", {
	  className: "c-copyright"
	}, void 0, "© ", _constants.AUTHOR, " ", _constants.COPYRIGHT);
	
	var Copyright = function Copyright() {
	  return _ref;
	};
	
	exports.default = Copyright;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(18);
	
	var _Copyright = __webpack_require__(119);
	
	var _Copyright2 = _interopRequireDefault(_Copyright);
	
	var _cartierLogoMin = __webpack_require__(302);
	
	var _cartierLogoMin2 = _interopRequireDefault(_cartierLogoMin);
	
	var _cartierLogoWhiteMin = __webpack_require__(301);
	
	var _cartierLogoWhiteMin2 = _interopRequireDefault(_cartierLogoWhiteMin);
	
	__webpack_require__(280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var _ref = (0, _jsx3.default)(_Copyright2.default, {});
	
	var Footer = function (_React$Component) {
	    (0, _inherits3.default)(Footer, _React$Component);
	
	    function Footer() {
	        (0, _classCallCheck3.default)(this, Footer);
	        return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Footer, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.foregroundColor !== this.props.foregroundColor;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return (0, _jsx3.default)("footer", {
	                style: this.style
	            }, void 0, this.props.shouldPresentCopyright ? _ref : null, (0, _jsx3.default)("a", {
	                href: "https://github.com/rayshan/cartier",
	                title: _constants.CARTIER_DESCRIPTION,
	                target: "_blank",
	                className: this.linkClassName
	            }, void 0, "Exhibition by", (0, _jsx3.default)("img", {
	                className: "logo",
	                src: this.logoPath,
	                alt: "Cartier Logo"
	            })));
	        }
	    }, {
	        key: "style",
	        get: function get() {
	            return {
	                color: this.props.foregroundColor
	            };
	        }
	    }, {
	        key: "logoPath",
	        get: function get() {
	            return this.props.foregroundColor ? _cartierLogoWhiteMin2.default : _cartierLogoMin2.default;
	        }
	    }, {
	        key: "linkClassName",
	        get: function get() {
	            return (this.props.isLessProminent ? "will-stand-out-on-hover" : "will-fade-on-hover") + " will-stand-out-on-active";
	        }
	    }]);
	    return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaInspector = undefined;
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(43);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(93);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _constants = __webpack_require__(18);
	
	var _BlurredMedia = __webpack_require__(198);
	
	var _BlurredMedia2 = _interopRequireDefault(_BlurredMedia);
	
	var _lodash = __webpack_require__(150);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _combokeys = __webpack_require__(70);
	
	var _combokeys2 = _interopRequireDefault(_combokeys);
	
	var _screenfull = __webpack_require__(90);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _Nav = __webpack_require__(203);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Footer = __webpack_require__(120);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var Background = function (_React$Component) {
	    (0, _inherits3.default)(Background, _React$Component);
	
	    function Background() {
	        (0, _classCallCheck3.default)(this, Background);
	        return (0, _possibleConstructorReturn3.default)(this, (Background.__proto__ || (0, _getPrototypeOf2.default)(Background)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Background, [{
	        key: "render",
	        value: function render() {
	            return (0, _jsx3.default)(_Link2.default, {
	                to: this.props.linkUri,
	                className: "c-detail-background"
	            }, void 0, _react2.default.createElement(_BlurredMedia2.default, this.mediaProps));
	        }
	    }, {
	        key: "mediaProps",
	        get: function get() {
	            var _props = this.props,
	                imageUri = _props.imageUri,
	                width = _props.width,
	                height = _props.height;
	
	            return {
	                blurRadius: 24,
	                imageUri: imageUri,
	                width: width,
	                height: height
	            };
	        }
	    }]);
	    return Background;
	}(_react2.default.Component);
	
	var MediaInspector = exports.MediaInspector = function (_React$Component2) {
	    (0, _inherits3.default)(MediaInspector, _React$Component2);
	    (0, _createClass3.default)(MediaInspector, [{
	        key: "initKeyManager",
	
	        /**
	         * Trying to do all key management for children in MediaInspector so we don't have to create
	         * and destroy keyManagers over and over as user stays in MediaInspector and navigates around.
	         */
	        value: function initKeyManager() {
	            var _this3 = this;
	
	            this.keyManager = new _combokeys2.default(document.documentElement);
	            this.keyManager.bind(["esc"], function () {
	                return _this3.context.router.push(_this3.backgroundLinkUri);
	            });
	            this.keyManager.bind(["f"], function () {
	                return !_this3.isPresentingInfo && MediaInspector.toggleFullScreen();
	            });
	            this.keyManager.bind(["i"], function () {
	                var destination = _this3.isPresentingInfo ? _this3.backgroundLinkUri : _this3.infoUri;
	                _this3.context.router.push(destination);
	            });
	            this.keyManager.bind(["left", "h", "k"], function () {
	                if (!_this3.isPresentingInfo) _this3.context.router.push(_this3.props.previousSlug);
	            });
	            this.keyManager.bind(["right", "l", "j"], function () {
	                if (!_this3.isPresentingInfo) _this3.context.router.push(_this3.props.nextSlug);
	            });
	        }
	        // =============================================================================================
	        // Event Handlers
	        // =============================================================================================
	
	    }, {
	        key: "_handleResize",
	        value: function _handleResize(event) {
	            event.stopPropagation();
	            this.setState({
	                width: Math.ceil(window.innerWidth / 4),
	                height: Math.ceil(window.innerHeight / 4)
	            });
	        }
	    }, {
	        key: "basePath",
	        get: function get() {
	            return "photos/" + this.props.slug;
	        }
	    }, {
	        key: "isPresentingInfo",
	        get: function get() {
	            return this.props.location.pathname.endsWith("/info");
	        }
	    }, {
	        key: "backgroundLinkUri",
	        get: function get() {
	            return this.isPresentingInfo && this.props.shouldPresentMedia ? "/" + this.props.slug : "/";
	        }
	    }, {
	        key: "backgroundImageUri",
	        get: function get() {
	            var extension = window.chrome ? "webp" : "jpeg";
	            // Use 1x due to resolution not being important after blur & enlargement
	            return this.basePath + "@1x." + extension;
	        }
	    }, {
	        key: "backgroundProps",
	        get: function get() {
	            return {
	                linkUri: this.backgroundLinkUri,
	                imageUri: this.backgroundImageUri,
	                width: this.state.width,
	                height: this.state.height,
	                key: this.props.slug
	            };
	        }
	    }, {
	        key: "childrenTransitionProps",
	        get: function get() {
	            var isPresentingInfo = this.props.isPresentingInfo;
	
	            var appearTimeout = isPresentingInfo ? _constants.cDetailInfoAppear : _constants.cDetailMainAppear,
	                enterTimeout = isPresentingInfo ? _constants.cDetailInfoEnter : _constants.cDetailMainEnter,
	                leaveTimeout = isPresentingInfo ? _constants.cDetailInfoLeave : _constants.cDetailMainLeave;
	            return {
	                // This wrapper div should be removed after this is resolved:
	                // https://github.com/facebook/react/pull/5408
	                component: "div",
	                //className: "c-detail-content-wrapper",
	                transitionName: this.isPresentingInfo ? "detail-info" : "detail-main",
	                transitionAppear: true,
	                transitionAppearTimeout: appearTimeout,
	                transitionEnterTimeout: enterTimeout,
	                transitionLeaveTimeout: leaveTimeout
	            };
	        }
	    }, {
	        key: "style",
	        get: function get() {
	            return {
	                backgroundColor: this.props.backgroundColor
	            };
	        }
	    }, {
	        key: "infoUri",
	        get: function get() {
	            return "/" + this.props.slug + "/info";
	        }
	    }, {
	        key: "navData",
	        get: function get() {
	            var cDetailMainNavData = !this.isPresentingInfo ? [{ label: "INFO", uri: this.infoUri }, { label: "FULLSCREEN", className: "full-screen-button" }] : [];
	            return [{ label: this.isPresentingInfo ? "DISMISS" : "PHOTOGRAPHY", uri: this.backgroundLinkUri }].concat(cDetailMainNavData);
	        }
	    }, {
	        key: "handleResize",
	        get: function get() {
	            if (!this.__handleResize) {
	                this.__handleResize = (0, _lodash2.default)(this._handleResize.bind(this), 128);
	            }
	            return this.__handleResize;
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }], [{
	        key: "toggleFullScreen",
	        value: function toggleFullScreen() {
	            if (_screenfull2.default.enabled) {
	                // Easier than reaching into children via ref and getting img element
	                _screenfull2.default.toggle(document.getElementById("full-screen-media"));
	            }
	        }
	    }, {
	        key: "backgroundTransitionProps",
	        get: function get() {
	            return {
	                // This wrapper div should be removed after this is resolved:
	                // https://github.com/facebook/react/pull/5408
	                component: "div",
	                //className: "c-detail-content-wrapper",
	                transitionName: "c-detail-background-fade",
	                transitionAppear: true,
	                transitionAppearTimeout: 1000,
	                transitionEnterTimeout: 1000,
	                transitionLeaveTimeout: 1000
	            };
	        }
	    }]);
	
	    function MediaInspector() {
	        (0, _classCallCheck3.default)(this, MediaInspector);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (MediaInspector.__proto__ || (0, _getPrototypeOf2.default)(MediaInspector)).call(this));
	
	        _this2.state = { width: null, height: null };
	        return _this2;
	    }
	    /**
	     * Container's offsetWidth causes reflow and may interfere with other component's rendering
	     */
	
	
	    (0, _createClass3.default)(MediaInspector, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.setState({
	                width: Math.ceil(window.innerWidth / 4),
	                height: Math.ceil(window.innerHeight / 4)
	            });
	            window.addEventListener("resize", this.handleResize);
	            this.initKeyManager();
	        }
	        /**
	         * When exiting detail view, this component receives a blank slug due to path being "/".
	         * We don't need to re-render, just need to let parent transition this component out.
	         */
	
	    }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !!nextProps.slug || nextState.width !== this.state.width || nextState.height !== this.state.height;
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.handleResize);
	            this.keyManager.detach();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var key = this.props.slug + this.isPresentingInfo;
	            // TODO: use dialog element instead of section when dialog element is widely supported
	            return (0, _jsx3.default)("section", {
	                className: "media-inspector",
	                style: this.style
	            }, void 0, _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                MediaInspector.backgroundTransitionProps,
	                _react2.default.createElement(Background, this.backgroundProps)
	            ), (0, _jsx3.default)(_Nav2.default, {
	                navData: this.navData,
	                color: this.props.foregroundColor
	            }), _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                this.childrenTransitionProps,
	                _react2.default.cloneElement(this.props.children, { key: key })
	            ), (0, _jsx3.default)(_Footer2.default, {
	                isLessProminent: true,
	                foregroundColor: this.props.foregroundColor,
	                shouldPresentCopyright: false
	            }));
	        }
	    }]);
	    return MediaInspector;
	}(_react2.default.Component);
	
	MediaInspector.contextTypes = {
	    router: _react2.default.PropTypes.object.isRequired
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(245), __esModule: true };

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(209);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(123);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(247);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(50)
	  , document = __webpack_require__(25).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(27) && !__webpack_require__(35)(function(){
	  return Object.defineProperty(__webpack_require__(130)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(128);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(75)
	  , $export        = __webpack_require__(28)
	  , redefine       = __webpack_require__(138)
	  , hide           = __webpack_require__(36)
	  , has            = __webpack_require__(29)
	  , Iterators      = __webpack_require__(74)
	  , $iterCreate    = __webpack_require__(253)
	  , setToStringTag = __webpack_require__(78)
	  , getPrototypeOf = __webpack_require__(136)
	  , ITERATOR       = __webpack_require__(37)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(57)
	  , createDesc     = __webpack_require__(58)
	  , toIObject      = __webpack_require__(31)
	  , toPrimitive    = __webpack_require__(83)
	  , has            = __webpack_require__(29)
	  , IE8_DOM_DEFINE = __webpack_require__(131)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(27) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(137)
	  , hiddenKeys = __webpack_require__(73).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(29)
	  , toObject    = __webpack_require__(82)
	  , IE_PROTO    = __webpack_require__(79)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(29)
	  , toIObject    = __webpack_require__(31)
	  , arrayIndexOf = __webpack_require__(249)(false)
	  , IE_PROTO     = __webpack_require__(79)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(36);

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(25)
	  , has            = __webpack_require__(29)
	  , DESCRIPTORS    = __webpack_require__(27)
	  , $export        = __webpack_require__(28)
	  , redefine       = __webpack_require__(138)
	  , META           = __webpack_require__(256).KEY
	  , $fails         = __webpack_require__(35)
	  , shared         = __webpack_require__(80)
	  , setToStringTag = __webpack_require__(78)
	  , uid            = __webpack_require__(59)
	  , wks            = __webpack_require__(37)
	  , wksExt         = __webpack_require__(85)
	  , wksDefine      = __webpack_require__(84)
	  , keyOf          = __webpack_require__(255)
	  , enumKeys       = __webpack_require__(250)
	  , isArray        = __webpack_require__(252)
	  , anObject       = __webpack_require__(49)
	  , toIObject      = __webpack_require__(31)
	  , toPrimitive    = __webpack_require__(83)
	  , createDesc     = __webpack_require__(58)
	  , _create        = __webpack_require__(76)
	  , gOPNExt        = __webpack_require__(259)
	  , $GOPD          = __webpack_require__(134)
	  , $DP            = __webpack_require__(30)
	  , $keys          = __webpack_require__(51)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(135).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(57).f  = $propertyIsEnumerable;
	  __webpack_require__(77).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(75)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(155);
	var ReactInstanceMap = __webpack_require__(41);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	exports.getReactInstanceMap = function () {
	  return ReactInstanceMap;
	};
	
	if (false) {
	  var ReactPerf = require('react-dom/lib/ReactPerf');
	  var ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	
	  exports.getReactPerf = function () {
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(110);
	
	var _actions = __webpack_require__(47);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(93);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Header = __webpack_require__(197);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(120);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(279);
	
	var _Grid = __webpack_require__(195);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GridSelector(state) {
	    // Must access state.reducer as it's combined via combineReducers with routeReducer
	    return {
	        mediaQuery: state.mediaQuery,
	        data: state.gridData
	    };
	}
	
	// =================================================================================================
	
	var GridConnected = (0, _reactRedux.connect)(GridSelector)(_Grid2.default);
	
	// =================================================================================================
	
	var _ref = (0, _jsx3.default)(_Header2.default, {});
	
	var _ref2 = (0, _jsx3.default)(_Footer2.default, {
	    shouldPresentCopyright: true
	});
	
	var App = function (_React$Component) {
	    (0, _inherits3.default)(App, _React$Component);
	
	    function App() {
	        (0, _classCallCheck3.default)(this, App);
	        return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(App, [{
	        key: "handleMediaQueryChange",
	
	        // =============================================================================================
	        // Event Handlers
	        // =============================================================================================
	        value: function handleMediaQueryChange() {
	            this.props.dispatch((0, _actions.matchMediaQuery)());
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }, {
	        key: "render",
	        value: function render() {
	            App.body.style.overflow = this.isInspectingMedia ? "hidden" : "visible";
	            return (0, _jsx3.default)("div", {
	                className: "c-app-container"
	            }, void 0, (0, _jsx3.default)(_reactAddonsCssTransitionGroup2.default, {
	                component: "div",
	                transitionName: "c-detail-fade",
	                transitionAppear: false,
	                transitionEnter: false,
	                transitionLeaveTimeout: 250
	            }, void 0, this.props.children), _ref, (0, _jsx3.default)(GridConnected, {
	                isInspectingMedia: this.isInspectingMedia
	            }), _ref2);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._mediaQueryLists = [];
	            var mediaQuery = void 0;
	            for (var key in _actions.mediaQueries) {
	                mediaQuery = _actions.mediaQueries[key];
	                // mediaQueries.XS === null because it's the default and doesn't need matching
	                if (mediaQuery) {
	                    mediaQuery.addListener(this.handleMediaQueryChange.bind(this));
	                    this._mediaQueryLists.push(mediaQuery);
	                }
	            }
	
	            this.handleMediaQueryChange();
	            //this._element.addEventListener("load", this.captureLatestImageLoad.bind(this), true);
	        }
	    }, {
	        key: "isInspectingMedia",
	        get: function get() {
	            return !!this.props.params.slug;
	        }
	    }], [{
	        key: "body",
	        get: function get() {
	            return window.document.body;
	        }
	    }]);
	    return App;
	}(_react2.default.Component);
	
	exports.default = App;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(150);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(47);
	
	var _GridItem = __webpack_require__(196);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _constants = __webpack_require__(18);
	
	var _combokeys = __webpack_require__(70);
	
	var _combokeys2 = _interopRequireDefault(_combokeys);
	
	var _pause = __webpack_require__(238);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	__webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var Grid = function (_React$Component) {
	    (0, _inherits3.default)(Grid, _React$Component);
	    (0, _createClass3.default)(Grid, [{
	        key: "initKeyManager",
	        value: function initKeyManager() {
	            var _this2 = this;
	
	            this.keyManager = (0, _pause2.default)(new _combokeys2.default(document.documentElement));
	            this.keyManager.bind(["left", "h", "k"], function () {
	                if (document.activeElement && document.activeElement instanceof HTMLAnchorElement && document.activeElement.classList.contains(_GridItem2.default.defaultProps.className)) {
	                    if (document.activeElement.previousSibling) {
	                        document.activeElement.previousSibling.focus();
	                    } else {
	                        _this2.gridItemElements[_this2.gridItemElements.length - 1].focus();
	                    }
	                } else {
	                    _this2.gridItemElements[0].focus();
	                }
	            });
	            this.keyManager.bind(["right", "l", "j"], function () {
	                if (document.activeElement && document.activeElement instanceof HTMLAnchorElement && document.activeElement.classList.contains(_GridItem2.default.defaultProps.className) && document.activeElement.nextSibling) {
	                    document.activeElement.nextSibling.focus();
	                } else {
	                    _this2.gridItemElements[0].focus();
	                }
	            });
	        }
	        // =============================================================================================
	        // Event Handlers
	        // =============================================================================================
	
	    }, {
	        key: "handleMouseEnterAtIndex",
	        value: function handleMouseEnterAtIndex(i) {
	            this.setState({ hoveredImageIndex: i });
	        }
	    }, {
	        key: "handleMouseLeave",
	        value: function handleMouseLeave() {
	            // handleMouseLeave is debounced. By the time it fires, user may be hovering above
	            // another image. Need to double check if any GridItem is still :hover.
	            if (!document.querySelector("." + _GridItem2.default.defaultProps.className + ":hover")) {
	                this.setState({ hoveredImageIndex: null });
	            }
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }, {
	        key: "columnWidth",
	        get: function get() {
	            return this.props.mediaQuery === _actions.mediaQueries.LG ? _constants.COLUMN_WIDTH_WIDE : _constants.COLUMN_WIDTH_NARROW;
	        }
	    }, {
	        key: "isScreenXs",
	        get: function get() {
	            return this.props.mediaQuery === _actions.mediaQueries.XS;
	        }
	    }, {
	        key: "shouldRenderAccessories",
	        get: function get() {
	            return this.props.mediaQuery === _actions.mediaQueries.MD || this.props.mediaQuery === _actions.mediaQueries.LG;
	        }
	        // get isLatestPercentageWidth() {
	        //     return !(this.props.mediaQuery === mediaQueries.MD) &&
	        //         !(this.props.mediaQuery === mediaQueries.LG);
	        // }
	
	    }, {
	        key: "gridItems",
	        get: function get() {
	            var _this3 = this;
	
	            return this.props.data.map(function (datum, i) {
	                var width = datum.dimensions[0],
	                    height = datum.dimensions[1],
	                    isLandscape = width > height,
	                    isActive = _this3.state.hoveredImageIndex === i,
	                    props = {
	                    foregroundColor: datum.colors[0],
	                    backgroundColor: datum.colors[1],
	                    uri: datum.slug + (_this3.isScreenXs ? "/info" : ""),
	                    key: i,
	                    shouldRenderAccessories: _this3.shouldRenderAccessories,
	                    isPercentageWidth: _this3.isScreenXs,
	                    columnWidth: _this3.columnWidth,
	                    slug: datum.slug,
	                    title: datum.title,
	                    aspectRatio: width / height,
	                    // Necessary to set c-landscape class, which styles c-reflection differently
	                    isLandscape: isLandscape,
	                    isActive: isActive
	                };
	
	                // Delegate grid items' event handling to parent grid
	                if (props.shouldRenderAccessories) {
	                    props.onMouseEnter = !isActive ? _this3.handleMouseEnterAtIndex.bind(_this3, i) : undefined;
	                    props.onMouseLeave = isActive ? _this3.handleMouseLeave.bind(_this3) : undefined;
	                }
	
	                // return isLatest ? <LatestGridItem {...props} /> : <GridItem {...props} />;
	                return _react2.default.createElement(_GridItem2.default, props);
	            });
	        }
	    }, {
	        key: "gridItemElements",
	        get: function get() {
	            if (!this._gridItemElements) {
	                this._gridItemElements = document.getElementsByClassName(_GridItem2.default.defaultProps.className);
	            }
	            return this._gridItemElements;
	        }
	    }, {
	        key: "className",
	        get: function get() {
	            return "c-grid" + (this.props.isInspectingMedia ? "" : " c-is-active") + (this.state.hoveredImageIndex !== null ? " c-dim" : "");
	        }
	    }]);
	
	    function Grid() {
	        (0, _classCallCheck3.default)(this, Grid);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this));
	
	        _this.state = { hoveredImageIndex: null };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Grid, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // Debounce here per http://stackoverflow.com/a/24679479/2152076
	            this.handleMouseLeave = (0, _lodash2.default)(this.handleMouseLeave, 350);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            if (!this.keyManager) this.initKeyManager();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            if (this.props.isInspectingMedia) {
	                this.keyManager.pause();
	            } else {
	                this.keyManager.unpause();
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            //console.log("mediaQuery = ", mediaQuery);
	            //console.log("isPercentageWidth = ", this.isPercentageWidth);
	
	            return (0, _jsx3.default)("section", {
	                className: this.className,
	                id: "grid"
	            }, void 0, this.gridItems);
	        }
	    }]);
	    return Grid;
	}(_react2.default.Component);
	
	exports.default = Grid;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(48);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(43);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _constants = __webpack_require__(18);
	
	var _Media = __webpack_require__(69);
	
	var _Frame = __webpack_require__(199);
	
	__webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var _ref = (0, _jsx3.default)(_Frame.MediaReflection, {});
	
	var GridItem = function (_React$Component) {
	    (0, _inherits3.default)(GridItem, _React$Component);
	    (0, _createClass3.default)(GridItem, [{
	        key: "handleLoad",
	
	        // =============================================================================================
	        // Event Handlers
	        // =============================================================================================
	        value: function handleLoad(event) {
	            event.stopPropagation();
	            this.setState({ mediaDidLoad: true });
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }, {
	        key: "shouldRenderAccessories",
	        get: function get() {
	            return this.props.shouldRenderAccessories && this.state.mediaDidLoad;
	        }
	    }, {
	        key: "className",
	        get: function get() {
	            var _props = this.props,
	                isLandscape = _props.isLandscape,
	                isActive = _props.isActive;
	
	            return this.props.className + (isLandscape ? " c-is-landscape" : "") + (isActive ? " c-is-active" : "");
	        }
	    }, {
	        key: "width",
	        get: function get() {
	            var _props2 = this.props,
	                isLandscape = _props2.isLandscape,
	                isPercentageWidth = _props2.isPercentageWidth,
	                columnWidth = _props2.columnWidth;
	
	            var result = void 0;
	            if (isPercentageWidth) {
	                result = "100%";
	            } else {
	                var landscapeScaleFactor = isLandscape ? 2 : 1,
	                    gutterCompensation = isLandscape ? _constants.GUTTER : 0,
	                    width = columnWidth * landscapeScaleFactor + gutterCompensation;
	                result = width + "px";
	            }
	            return result;
	        }
	    }, {
	        key: "gridItemProps",
	        get: function get() {
	            var _props3 = this.props,
	                uri = _props3.uri,
	                onMouseEnter = _props3.onMouseEnter,
	                onMouseLeave = _props3.onMouseLeave;
	
	            var props = {
	                to: uri,
	                className: this.className
	            };
	            if (this.state.mediaDidLoad) {
	                props.onMouseEnter = onMouseEnter;
	                props.onMouseLeave = onMouseLeave;
	            }
	            return props;
	        }
	    }, {
	        key: "mediaProps",
	        get: function get() {
	            var _props4 = this.props,
	                aspectRatio = _props4.aspectRatio,
	                foregroundColor = _props4.foregroundColor,
	                backgroundColor = _props4.backgroundColor;
	
	            return {
	                basePrefix: "photos/" + this.props.slug,
	                title: this.props.title,
	                width: this.width,
	                aspectRatio: aspectRatio,
	                foregroundColor: foregroundColor,
	                backgroundColor: backgroundColor
	                // didLoad: this.state.mediaDidLoad,
	                // onLoad: !this.state.mediaDidLoad ? this.handleLoad.bind(this) : undefined
	            };
	        }
	    }, {
	        key: "onLoadAttribute",
	        get: function get() {
	            return { onLoad: !this.state.mediaDidLoad ? this.handleLoad.bind(this) : null };
	        }
	    }, {
	        key: "title",
	        get: function get() {
	            var _props5 = this.props,
	                backgroundColor = _props5.backgroundColor,
	                title = _props5.title;
	
	            return (0, _jsx3.default)("h2", {
	                className: "title",
	                style: { color: backgroundColor }
	            }, void 0, title);
	        }
	    }]);
	
	    function GridItem() {
	        (0, _classCallCheck3.default)(this, GridItem);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (GridItem.__proto__ || (0, _getPrototypeOf2.default)(GridItem)).call(this));
	
	        _this.state = { mediaDidLoad: false };
	        return _this;
	    }
	
	    (0, _createClass3.default)(GridItem, [{
	        key: "render",
	        value: function render() {
	            var _props6 = this.props,
	                backgroundColor = _props6.backgroundColor,
	                isPercentageWidth = _props6.isPercentageWidth;
	
	            return _react2.default.createElement(
	                _Link2.default,
	                (0, _extends3.default)({}, this.gridItemProps, this.onLoadAttribute),
	                _react2.default.createElement(_Media.MediaThumbnail, this.mediaProps),
	                isPercentageWidth ? this.title : null,
	                this.shouldRenderAccessories ? _ref : null,
	                this.shouldRenderAccessories ? (0, _jsx3.default)(_Frame.MediaFrame, {
	                    shadowColor: backgroundColor
	                }) : null
	            );
	        }
	    }]);
	    return GridItem;
	}(_react2.default.Component);
	
	GridItem.defaultProps = {
	    className: "c-grid-item"
	};
	
	exports.default = GridItem;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StaticComponent = __webpack_require__(56);
	
	var _StaticComponent2 = _interopRequireDefault(_StaticComponent);
	
	var _constants = __webpack_require__(18);
	
	__webpack_require__(283);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var _ref = (0, _jsx3.default)("hr", {});
	
	var Header = function (_Static) {
	    (0, _inherits3.default)(Header, _Static);
	
	    function Header() {
	        (0, _classCallCheck3.default)(this, Header);
	        return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Header, [{
	        key: "render",
	        value: function render() {
	            return (0, _jsx3.default)("header", {}, void 0, (0, _jsx3.default)("a", {
	                href: _constants.MASTHEAD.LINK
	            }, void 0, (0, _jsx3.default)("h1", {}, void 0, _constants.MASTHEAD.TITLE)), _ref, (0, _jsx3.default)("nav", {}, void 0, Header.navItems));
	        }
	    }], [{
	        key: "navItems",
	        get: function get() {
	            return _constants.LINK_DATA.map(function (datum) {
	                return (0, _jsx3.default)("div", {
	                    className: "nav-item"
	                }, datum.label, (0, _jsx3.default)("a", {
	                    className: "will-fade-on-hover will-stand-out-on-active",
	                    href: datum.uri
	                }, void 0, datum.label));
	            });
	        }
	    }]);
	    return Header;
	}(_StaticComponent2.default);
	
	// =================================================================================================
	
	exports.default = Header;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stackBlur = __webpack_require__(200);
	
	var _stackBlur2 = _interopRequireDefault(_stackBlur);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlurredMedia = function (_React$Component) {
	    (0, _inherits3.default)(BlurredMedia, _React$Component);
	    (0, _createClass3.default)(BlurredMedia, [{
	        key: "performStackBlur",
	        value: function performStackBlur() {
	            (0, _stackBlur2.default)(this.img, this.canvas, this.props.blurRadius, this.props.width, this.props.height);
	        }
	        // =============================================================================================
	        // Event Handlers
	        // =============================================================================================
	
	    }, {
	        key: "handleLoad",
	        value: function handleLoad(event) {
	            if (event) event.stopPropagation();
	            this.setState({ mediaDidLoad: true });
	            this.img.onload = null;
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }]);
	
	    function BlurredMedia() {
	        (0, _classCallCheck3.default)(this, BlurredMedia);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BlurredMedia.__proto__ || (0, _getPrototypeOf2.default)(BlurredMedia)).call(this));
	
	        _this.state = { mediaDidLoad: false };
	        /**
	         * @private
	         * @type {?HTMLCanvasElement}
	         */
	        _this.canvas = undefined;
	        return _this;
	    }
	
	    (0, _createClass3.default)(BlurredMedia, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.canvas.width = this.props.width;
	            this.canvas.height = this.props.height;
	            // TODO: detect & use createImageBitmap(), can eliminate handleLoad:
	            // https://developers.google.com/web/updates/2016/03/createimagebitmap-in-chrome-50
	            this.img = new Image();
	            this.img.onload = this.handleLoad.bind(this);
	            this.img.src = this.props.imageUri;
	        }
	    }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextState.mediaDidLoad !== this.state.mediaDidLoad;
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            if (this.state.mediaDidLoad) this.performStackBlur();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement("canvas", { ref: function ref(component) {
	                    return _this2.canvas = component;
	                } });
	        }
	    }]);
	    return BlurredMedia;
	}(_react2.default.Component);
	
	exports.default = BlurredMedia;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaReflection = exports.MediaFrame = undefined;
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StaticComponent = __webpack_require__(56);
	
	var _StaticComponent2 = _interopRequireDefault(_StaticComponent);
	
	var _hexRgb = __webpack_require__(303);
	
	var _hexRgb2 = _interopRequireDefault(_hexRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var MediaFrame = function (_Static) {
	    (0, _inherits3.default)(MediaFrame, _Static);
	
	    function MediaFrame() {
	        (0, _classCallCheck3.default)(this, MediaFrame);
	        return (0, _possibleConstructorReturn3.default)(this, (MediaFrame.__proto__ || (0, _getPrototypeOf2.default)(MediaFrame)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MediaFrame, [{
	        key: "render",
	        value: function render() {
	            //let style = this.props.style || {};
	            //style.boxShadow = boxShadowFrom(hexRgb(this.props.shadowColor));
	            var style = {
	                width: this.props.width,
	                boxShadow: this.shadow
	            };
	            return (0, _jsx3.default)("div", {
	                className: "c-frame",
	                style: style
	            }, void 0, this.props.children);
	        }
	    }, {
	        key: "shadow",
	        get: function get() {
	            var color = (0, _hexRgb2.default)(this.props.shadowColor);
	            return (
	                // Slight vignette effect on "mat"
	                "0 0 16px rgba(" + color + ", 0.15) inset," + (
	                // Below taken from Angular Material, .md-whiteframe-20dp
	                // https://material.angularjs.org/latest/demo/whiteframe
	                "0 10px 13px -6px rgba(" + color + ", .2),") + ("0 20px 31px 3px rgba(" + color + ", .14),") + ("0 8px 38px 7px rgba(" + color + ", .12)")
	            );
	        }
	    }]);
	    return MediaFrame;
	}(_StaticComponent2.default);
	
	// =================================================================================================
	
	// CReflection is just a styled rectangle; container needed to set overflow hidden to clip
	// CReflection into polygon.
	
	
	var _ref = (0, _jsx3.default)("div", {
	    className: "c-frame-reflection-container"
	}, void 0, (0, _jsx3.default)("div", {
	    className: "c-frame-reflection"
	}));
	
	var MediaReflection = function (_Static2) {
	    (0, _inherits3.default)(MediaReflection, _Static2);
	
	    function MediaReflection() {
	        (0, _classCallCheck3.default)(this, MediaReflection);
	        return (0, _possibleConstructorReturn3.default)(this, (MediaReflection.__proto__ || (0, _getPrototypeOf2.default)(MediaReflection)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MediaReflection, [{
	        key: "render",
	        value: function render() {
	            return _ref;
	        }
	    }]);
	    return MediaReflection;
	}(_StaticComponent2.default);
	
	// =================================================================================================
	
	exports.MediaFrame = MediaFrame;
	exports.MediaReflection = MediaReflection;

/***/ },
/* 200 */
/***/ function(module, exports) {

	"use strict";
	
	// Slightly modified from https://github.com/javierbyte/react-blur/blob/master/lib/StackBlur.js
	
	var mul_table = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];
	
	var shg_table = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
	
	function stackBlurImage(img, canvas, radius, w, h) {
	    var nw = img.naturalWidth;
	    var nh = img.naturalHeight;
	
	    canvas.style.width = w + "px";
	    canvas.style.height = h + "px";
	    canvas.width = w;
	    canvas.height = h;
	
	    var context = canvas.getContext("2d");
	    context.clearRect(0, 0, w, h);
	
	    var ratio = 1;
	    if (nw / w > nh / h) {
	        ratio = nh / h;
	    } else {
	        ratio = nw / w;
	    }
	
	    var drawW = nw / ratio;
	    var drawH = nh / ratio;
	
	    try {
	        context.drawImage(img, Math.floor((drawW - w) / -2), Math.floor((drawH - h) / -2), Math.ceil(drawW), Math.ceil(drawH));
	        context.fillStyle = "rgba(0, 0, 0, 0.5)";
	        context.fillRect(Math.floor((drawW - w) / -2), Math.floor((drawH - h) / -2), Math.ceil(drawW), Math.ceil(drawH));
	    } catch (e) {
	        console.error('There was a problem drawing the image. ' + e);
	    }
	
	    if (isNaN(radius) || radius < 1) return;
	    stackBlurCanvasRGB(canvas, 0, 0, w, h, radius);
	}
	
	function stackBlurCanvasRGB(canvas, top_x, top_y, width, height, radius) {
	    if (isNaN(radius) || radius < 1) return;
	    radius |= 0;
	
	    var context = canvas.getContext("2d");
	    var imageData;
	
	    try {
	        imageData = context.getImageData(top_x, top_y, width, height);
	    } catch (e) {
	        throw new Error("unable to access image data: " + e);
	    }
	
	    var pixels = imageData.data;
	
	    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, r_out_sum, g_out_sum, b_out_sum, r_in_sum, g_in_sum, b_in_sum, pr, pg, pb, rbs;
	
	    var div = radius + radius + 1;
	    var w4 = width << 2;
	    var widthMinus1 = width - 1;
	    var heightMinus1 = height - 1;
	    var radiusPlus1 = radius + 1;
	    var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
	
	    var stackStart = new BlurStack();
	    var stack = stackStart;
	    for (i = 1; i < div; i++) {
	        stack = stack.next = new BlurStack();
	        if (i == radiusPlus1) var stackEnd = stack;
	    }
	    stack.next = stackStart;
	    var stackIn = null;
	    var stackOut = null;
	
	    yw = yi = 0;
	
	    var mul_sum = mul_table[radius];
	    var shg_sum = shg_table[radius];
	
	    for (y = 0; y < height; y++) {
	        r_in_sum = g_in_sum = b_in_sum = r_sum = g_sum = b_sum = 0;
	
	        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
	        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
	        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
	
	        r_sum += sumFactor * pr;
	        g_sum += sumFactor * pg;
	        b_sum += sumFactor * pb;
	
	        stack = stackStart;
	
	        for (i = 0; i < radiusPlus1; i++) {
	            stack.r = pr;
	            stack.g = pg;
	            stack.b = pb;
	            stack = stack.next;
	        }
	
	        for (i = 1; i < radiusPlus1; i++) {
	            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
	            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
	            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
	            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
	
	            r_in_sum += pr;
	            g_in_sum += pg;
	            b_in_sum += pb;
	
	            stack = stack.next;
	        }
	
	        stackIn = stackStart;
	        stackOut = stackEnd;
	        for (x = 0; x < width; x++) {
	            pixels[yi] = r_sum * mul_sum >> shg_sum;
	            pixels[yi + 1] = g_sum * mul_sum >> shg_sum;
	            pixels[yi + 2] = b_sum * mul_sum >> shg_sum;
	
	            r_sum -= r_out_sum;
	            g_sum -= g_out_sum;
	            b_sum -= b_out_sum;
	
	            r_out_sum -= stackIn.r;
	            g_out_sum -= stackIn.g;
	            b_out_sum -= stackIn.b;
	
	            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
	
	            r_in_sum += stackIn.r = pixels[p];
	            g_in_sum += stackIn.g = pixels[p + 1];
	            b_in_sum += stackIn.b = pixels[p + 2];
	
	            r_sum += r_in_sum;
	            g_sum += g_in_sum;
	            b_sum += b_in_sum;
	
	            stackIn = stackIn.next;
	
	            r_out_sum += pr = stackOut.r;
	            g_out_sum += pg = stackOut.g;
	            b_out_sum += pb = stackOut.b;
	
	            r_in_sum -= pr;
	            g_in_sum -= pg;
	            b_in_sum -= pb;
	
	            stackOut = stackOut.next;
	
	            yi += 4;
	        }
	        yw += width;
	    }
	
	    for (x = 0; x < width; x++) {
	        g_in_sum = b_in_sum = r_in_sum = g_sum = b_sum = r_sum = 0;
	
	        yi = x << 2;
	        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
	        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
	        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
	
	        r_sum += sumFactor * pr;
	        g_sum += sumFactor * pg;
	        b_sum += sumFactor * pb;
	
	        stack = stackStart;
	
	        for (i = 0; i < radiusPlus1; i++) {
	            stack.r = pr;
	            stack.g = pg;
	            stack.b = pb;
	            stack = stack.next;
	        }
	
	        yp = width;
	
	        for (i = 1; i <= radius; i++) {
	            yi = yp + x << 2;
	
	            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
	            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
	            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
	
	            r_in_sum += pr;
	            g_in_sum += pg;
	            b_in_sum += pb;
	
	            stack = stack.next;
	
	            if (i < heightMinus1) {
	                yp += width;
	            }
	        }
	
	        yi = x;
	        stackIn = stackStart;
	        stackOut = stackEnd;
	        for (y = 0; y < height; y++) {
	            p = yi << 2;
	            pixels[p] = r_sum * mul_sum >> shg_sum;
	            pixels[p + 1] = g_sum * mul_sum >> shg_sum;
	            pixels[p + 2] = b_sum * mul_sum >> shg_sum;
	
	            r_sum -= r_out_sum;
	            g_sum -= g_out_sum;
	            b_sum -= b_out_sum;
	
	            r_out_sum -= stackIn.r;
	            g_out_sum -= stackIn.g;
	            b_out_sum -= stackIn.b;
	
	            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
	
	            r_sum += r_in_sum += stackIn.r = pixels[p];
	            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
	            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
	
	            stackIn = stackIn.next;
	
	            r_out_sum += pr = stackOut.r;
	            g_out_sum += pg = stackOut.g;
	            b_out_sum += pb = stackOut.b;
	
	            r_in_sum -= pr;
	            g_in_sum -= pg;
	            b_in_sum -= pb;
	
	            stackOut = stackOut.next;
	
	            yi += width;
	        }
	    }
	    context.putImageData(imageData, top_x, top_y);
	}
	
	function BlurStack() {
	    this.r = 0;
	    this.g = 0;
	    this.b = 0;
	    this.a = 0;
	    this.next = null;
	}
	
	module.exports = stackBlurImage;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(48);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Copyright = __webpack_require__(119);
	
	var _Copyright2 = _interopRequireDefault(_Copyright);
	
	var _Media = __webpack_require__(69);
	
	var _StaticComponent = __webpack_require__(56);
	
	var _StaticComponent2 = _interopRequireDefault(_StaticComponent);
	
	var _constants = __webpack_require__(18);
	
	__webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	/**
	 * For figcaption link - no official Google Image Search API; manually constructing the URI
	 * @see http://stackoverflow.com/a/21530368/2152076
	 */
	var Map = function (_Static) {
	    (0, _inherits3.default)(Map, _Static);
	
	    function Map() {
	        (0, _classCallCheck3.default)(this, Map);
	        return (0, _possibleConstructorReturn3.default)(this, (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Map, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                mapUri = _props.mapUri,
	                locationName = _props.locationName;
	
	            return (0, _jsx3.default)("figure", {
	                className: "c-map"
	            }, void 0, (0, _jsx3.default)("a", {
	                href: mapUri,
	                target: "_blank",
	                title: "Open in Google Maps"
	            }, void 0, _react2.default.createElement(_Media.Media, (0, _extends3.default)({
	                ref: function ref(component) {
	                    return _this2.media = component;
	                }
	            }, this.mediaProps))), (0, _jsx3.default)("figcaption", {}, void 0, (0, _jsx3.default)("a", {
	                href: "https://www.google.com/search?q=" + locationName + "&tbm=isch",
	                target: "_blank",
	                title: "Search for more images",
	                className: "will-fade-on-hover will-stand-out-on-active"
	            }, void 0, locationName)));
	            // <img
	            //     src={`maps/${slug}-location-map@1x.png`}
	            //     alt={slug}
	            //     className="will-dim-on-active"
	            // />
	        }
	    }, {
	        key: "mediaProps",
	
	        /**
	         * Maps are hardcoded to have GOLDEN_RATIO as aspectRatio; see gulp task in map.js
	         */
	        get: function get() {
	            return {
	                id: "full-screen-media",
	                basePrefix: "maps/" + this.props.slug + "-location-map",
	                title: this.props.title,
	                isLandscape: true,
	                suffix: "png"
	            };
	        }
	    }]);
	    return Map;
	}(_StaticComponent2.default);
	
	var Tags = function Tags(_ref) {
	    var data = _ref.data,
	        backgroundColor = _ref.backgroundColor;
	
	    var elements = data.map(function (datum, i) {
	        return (0, _jsx3.default)("span", {
	            className: "c-label",
	            style: { backgroundColor: backgroundColor }
	        }, i, datum);
	    });
	    return (0, _jsx3.default)("div", {}, void 0, elements);
	};
	
	var Weather = function Weather(_ref2) {
	    var temperature = _ref2.temperature,
	        windSpeed = _ref2.windSpeed,
	        windDirection = _ref2.windDirection,
	        summary = _ref2.summary;
	
	    /**
	     * METAR wind direction is the direction from which wind originates. E.g. 160 is SSE wind.
	     * Subtracting 180° to flip unicode arrow symbol around.
	     * Subtracting 90° due to unicode arrow symbol pointing east by default.
	     */
	    var _wind = windSpeed ? (0, _jsx3.default)("span", {}, void 0, " ・ " + Math.round(windSpeed * _constants.KT_TO_KPH) + " km/h ", (0, _jsx3.default)("span", {
	        className: "wind-symbol",
	        style: { transform: "rotate(" + (windDirection - 180 - 90) + "deg)" }
	    }, void 0, "➤")) : null;
	    var _temperature = temperature ? temperature + " ℃" : null,
	        _summary = summary ? " ・ " + summary : null;
	    return (0, _jsx3.default)("div", {}, void 0, _temperature, _wind, _summary);
	};
	
	var _ref3 = (0, _jsx3.default)(_Copyright2.default, {});
	
	var Info = function (_React$Component) {
	    (0, _inherits3.default)(Info, _React$Component);
	
	    function Info() {
	        (0, _classCallCheck3.default)(this, Info);
	        return (0, _possibleConstructorReturn3.default)(this, (Info.__proto__ || (0, _getPrototypeOf2.default)(Info)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Info, [{
	        key: "shouldComponentUpdate",
	
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.slug ? true : false;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                title = _props2.title,
	                month = _props2.month,
	                year = _props2.year,
	                tags = _props2.tags,
	                backgroundColor = _props2.backgroundColor;
	
	            return (0, _jsx3.default)("section", {
	                id: "media-inspector-info",
	                style: this.style
	            }, void 0, (0, _jsx3.default)("h1", {
	                className: "title"
	            }, void 0, title), _react2.default.createElement(Map, this.mapProps), (0, _jsx3.default)("div", {
	                className: "c-metadata"
	            }, void 0, (0, _jsx3.default)("span", {}, void 0, month, " ", year), _react2.default.createElement(Weather, this.props.weather), (0, _jsx3.default)(Tags, {
	                data: tags,
	                backgroundColor: backgroundColor
	            }), _ref3));
	        }
	    }, {
	        key: "mapProps",
	        get: function get() {
	            return {
	                mapUri: "https://maps.google.com/?q=" + (this.props.location.coordinates[0] + "," + this.props.location.coordinates[1]),
	                slug: this.props.slug,
	                locationName: this.props.location.name
	            };
	        }
	    }, {
	        key: "style",
	        get: function get() {
	            return {
	                color: this.props.foregroundColor
	            };
	        }
	    }]);
	    return Info;
	}(_react2.default.Component);
	
	Info.defaultProps = {
	    location: { coordinates: [] },
	    tags: []
	};
	
	exports.default = Info;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(48);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _getPrototypeOf = __webpack_require__(11);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(13);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(15);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(14);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(43);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _StaticComponent = __webpack_require__(56);
	
	var _StaticComponent2 = _interopRequireDefault(_StaticComponent);
	
	var _Media = __webpack_require__(69);
	
	var _actions = __webpack_require__(47);
	
	__webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	/**
	 * SVG based on Google Material Icons
	 */
	var _ref = (0, _jsx3.default)("path", {
	    d: "M0 0h48v48H0z",
	    fill: "none"
	});
	
	var PaginationLink = function (_Static) {
	    (0, _inherits3.default)(PaginationLink, _Static);
	
	    function PaginationLink() {
	        (0, _classCallCheck3.default)(this, PaginationLink);
	        return (0, _possibleConstructorReturn3.default)(this, (PaginationLink.__proto__ || (0, _getPrototypeOf2.default)(PaginationLink)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(PaginationLink, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                uri = _props.uri,
	                title = _props.title,
	                color = _props.color;
	
	            return (0, _jsx3.default)(_Link2.default, {
	                to: uri,
	                title: title,
	                className: "pagination-link will-stand-out-on-hover " + this.props.direction
	            }, void 0, (0, _jsx3.default)("svg", {
	                xmlns: "http://www.w3.org/2000/svg",
	                viewBox: "0 0 48 48",
	                style: { fill: color },
	                className: "pagination-link-symbol"
	            }, void 0, (0, _jsx3.default)("path", {
	                d: this.path
	            }), _ref));
	        }
	    }, {
	        key: "path",
	        get: function get() {
	            return this.props.direction === "previous" ? "M30.83 14.83L28 12 16 24l12 12 2.83-2.83L21.66 24z" : "M20 12l-2.83 2.83L26.34 24l-9.17 9.17L20 36l12-12z";
	        }
	    }]);
	    return PaginationLink;
	}(_StaticComponent2.default);
	
	var MediaAndAccessoryContainer = function (_React$Component) {
	    (0, _inherits3.default)(MediaAndAccessoryContainer, _React$Component);
	    (0, _createClass3.default)(MediaAndAccessoryContainer, [{
	        key: "polyfillPicture",
	        value: function polyfillPicture() {
	            if (this.props.didLoadPicturePolyfill && !this.state.didPolyfillPicture) {
	                window.picturefill({
	                    elements: [this.media.img]
	                });
	                this.setState({ didPolyfillPicture: true });
	            }
	        }
	        // =============================================================================================
	        // Life Cycle Hooks
	        // =============================================================================================
	
	    }, {
	        key: "mediaProps",
	        get: function get() {
	            // TODO: recalculate shouldRestrictHeight upon resize; not a priority as user is unlikely
	            // to resize viewport while looking at an image, and if they do, they're unlikely to remain
	            // on an image for a long period of time. When they move on to the next image, this will be
	            // recalculated according to new viewport size.
	            var _props2 = this.props,
	                aspectRatio = _props2.aspectRatio,
	                backgroundColor = _props2.backgroundColor,
	                foregroundColor = _props2.foregroundColor,
	                isLandscape = _props2.isLandscape,
	                shouldRestrictWidth = window.innerWidth * 0.9 < window.innerHeight * 0.85 * aspectRatio;
	
	            return {
	                id: "full-screen-media",
	                basePrefix: "photos/" + this.props.slug,
	                title: this.props.title,
	                isLandscape: isLandscape,
	                width: shouldRestrictWidth ? "90vw" : Math.floor(85 * aspectRatio) + "vh",
	                height: !shouldRestrictWidth ? "85vh" : Math.floor(90 / aspectRatio) + "vw",
	                foregroundColor: foregroundColor,
	                backgroundColor: backgroundColor
	            };
	        }
	    }, {
	        key: "style",
	        get: function get() {
	            return {
	                color: this.props.foregroundColor
	            };
	        }
	    }]);
	
	    function MediaAndAccessoryContainer() {
	        (0, _classCallCheck3.default)(this, MediaAndAccessoryContainer);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (MediaAndAccessoryContainer.__proto__ || (0, _getPrototypeOf2.default)(MediaAndAccessoryContainer)).call(this));
	
	        _this2.state = { didPolyfillPicture: false };
	        return _this2;
	    }
	
	    (0, _createClass3.default)(MediaAndAccessoryContainer, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var needsPicturePolyfill = !window.HTMLPictureElement;
	            if (needsPicturePolyfill && !this.props.didLoadPicturePolyfill) {
	                this.props.dispatch((0, _actions.loadPicturePolyfill)());
	            }
	            this.polyfillPicture();
	        }
	        /**
	         * This instance should not re-render when there's no slug while going back to grid,
	         * or when slug changes - it doesn't need to render a new slug as router
	         * will create a new instance to render the new slug
	         */
	
	    }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.slug !== this.props.slug && nextProps.didLoadPicturePolyfill;
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.polyfillPicture();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                slug = _props3.slug,
	                title = _props3.title,
	                foregroundColor = _props3.foregroundColor;
	
	            return (0, _jsx3.default)("section", {
	                className: "media-and-accessory-container",
	                style: this.style
	            }, void 0, (0, _jsx3.default)("div", {
	                className: "content-container"
	            }, void 0, (0, _jsx3.default)(_Link2.default, {
	                to: "/" + slug + "/info"
	            }, void 0, _react2.default.createElement(_Media.Media, (0, _extends3.default)({
	                ref: function ref(component) {
	                    return _this3.media = component;
	                }
	            }, this.mediaProps)), (0, _jsx3.default)("h1", {
	                className: "title will-fade-on-hover will-stand-out-on-active"
	            }, void 0, title)), (0, _jsx3.default)(PaginationLink, {
	                direction: "previous",
	                uri: "/" + this.props.previous.slug,
	                title: this.props.previous.title,
	                color: foregroundColor
	            }), (0, _jsx3.default)(PaginationLink, {
	                direction: "next",
	                uri: "/" + this.props.next.slug,
	                title: this.props.next.title,
	                color: foregroundColor
	            })));
	        }
	    }]);
	    return MediaAndAccessoryContainer;
	}(_react2.default.Component);
	
	exports.default = MediaAndAccessoryContainer;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jsx2 = __webpack_require__(10);
	
	var _jsx3 = _interopRequireDefault(_jsx2);
	
	var _extends2 = __webpack_require__(48);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(43);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MediaInspector = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// =================================================================================================
	
	var Nav = function Nav(_ref) {
	    var navData = _ref.navData,
	        color = _ref.color;
	
	    var style = { color: color },
	        linkPropsWithClassNameAndIndex = function linkPropsWithClassNameAndIndex(className, i) {
	        return {
	            className: (className || "") + " nav-item will-stand-out-on-hover will-stand-out-on-active",
	            key: i
	        };
	    },
	        navItems = navData.map(function (_ref2, i) {
	        var label = _ref2.label,
	            uri = _ref2.uri,
	            className = _ref2.className;
	        return uri ? _react2.default.createElement(
	            _Link2.default,
	            (0, _extends3.default)({}, linkPropsWithClassNameAndIndex(className, i), { to: uri }),
	            label
	        ) : _react2.default.createElement(
	            "span",
	            (0, _extends3.default)({}, linkPropsWithClassNameAndIndex(className, i), {
	                onClick: label === "FULLSCREEN" ? _MediaInspector.MediaInspector.toggleFullScreen : null
	            }),
	            label
	        );
	    });
	    return (0, _jsx3.default)("nav", {
	        className: "nav",
	        style: style
	    }, void 0, navItems);
	};
	
	exports.default = Nav;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(122);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.reducer = reducer;
	
	var _actions = __webpack_require__(47);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {LOCATION_CHANGE} from "react-router-redux"
	
	// =================================================================================================
	
	var initialState = {
	    mediaQuery: actions.matchMediaQuery().mediaQuery,
	    didLoadPicturePolyfill: false
	}; // Redux reducers
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case actions.MATCH_MEDIA_QUERY:
	            return (0, _assign2.default)({}, state, {
	                mediaQuery: action.mediaQuery
	            });
	
	        case actions.FETCH_GRID_DATA:
	            return (0, _assign2.default)({}, state, {
	                gridData: action.data
	            });
	
	        case actions.FETCH_PHOTO_DATA:
	            return (0, _assign2.default)({}, state, {
	                photoData: action.data
	            });
	
	        case actions.SET_BACKGROUND_IMAGE_URI:
	            return (0, _assign2.default)({}, state, {
	                backgroundImageUri: action.backgroundImageUri
	            });
	
	        case actions.DID_LOAD_PICTURE_POLYFILL:
	            return (0, _assign2.default)({}, state, {
	                didLoadPicturePolyfill: action.didLoadPicturePolyfill
	            });
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(240), __esModule: true };

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(241), __esModule: true };

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(243), __esModule: true };

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(244), __esModule: true };

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(246), __esModule: true };

/***/ },
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ function(module, exports) {

	/* eslint-env node, browser */
	'use strict'
	/**
	 * adds a pause and unpause method to Combokeys
	 * this allows you to enable or disable keyboard shortcuts
	 * without having to reset Combokeys and rebind everything
	 */
	module.exports = function (Combokeys) {
	  var originalStopCallback = Combokeys.stopCallback
	  var enabled = true
	
	  Combokeys.stopCallback = function (e, element, combo) {
	    if (!enabled) {
	      return true
	    }
	
	    return originalStopCallback(e, element, combo)
	  }
	
	  Combokeys.pause = function () {
	    enabled = false
	  }
	
	  Combokeys.unpause = function () {
	    enabled = true
	  }
	
	  return Combokeys
	}


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	module.exports = __webpack_require__(19).Object.assign;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(267);
	var $Object = __webpack_require__(19).Object;
	module.exports = function create(P, D){
	  return $Object.create(P, D);
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(268);
	var $Object = __webpack_require__(19).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(269);
	module.exports = __webpack_require__(19).Object.getPrototypeOf;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(270);
	module.exports = __webpack_require__(19).Object.setPrototypeOf;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(139);
	module.exports = __webpack_require__(19).Symbol['for'];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(139);
	__webpack_require__(271);
	__webpack_require__(273);
	__webpack_require__(274);
	module.exports = __webpack_require__(19).Symbol;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(272);
	__webpack_require__(275);
	module.exports = __webpack_require__(85).f('iterator');

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(31)
	  , toLength  = __webpack_require__(264)
	  , toIndex   = __webpack_require__(263);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(51)
	  , gOPS    = __webpack_require__(77)
	  , pIE     = __webpack_require__(57);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(25).document && document.documentElement;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(128);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(76)
	  , descriptor     = __webpack_require__(58)
	  , setToStringTag = __webpack_require__(78)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(36)(IteratorPrototype, __webpack_require__(37)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(51)
	  , toIObject = __webpack_require__(31);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(59)('meta')
	  , isObject = __webpack_require__(50)
	  , has      = __webpack_require__(29)
	  , setDesc  = __webpack_require__(30).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(35)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(51)
	  , gOPS     = __webpack_require__(77)
	  , pIE      = __webpack_require__(57)
	  , toObject = __webpack_require__(82)
	  , IObject  = __webpack_require__(132)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(35)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(30)
	  , anObject = __webpack_require__(49)
	  , getKeys  = __webpack_require__(51);
	
	module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(31)
	  , gOPN      = __webpack_require__(135).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(28)
	  , core    = __webpack_require__(19)
	  , fails   = __webpack_require__(35);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(50)
	  , anObject = __webpack_require__(49);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(129)(Function.call, __webpack_require__(134).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(81)
	  , defined   = __webpack_require__(72);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(81)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(81)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(248)
	  , step             = __webpack_require__(254)
	  , Iterators        = __webpack_require__(74)
	  , toIObject        = __webpack_require__(31);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(133)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(28);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(257)});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(28)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(76)});

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(28);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', {defineProperty: __webpack_require__(30).f});

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(82)
	  , $getPrototypeOf = __webpack_require__(136);
	
	__webpack_require__(260)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(28);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(261).set});

/***/ },
/* 271 */
/***/ function(module, exports) {



/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(262)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(133)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(84)('asyncIterator');

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(84)('observable');

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(265);
	var global        = __webpack_require__(25)
	  , hide          = __webpack_require__(36)
	  , Iterators     = __webpack_require__(74)
	  , TO_STRING_TAG = __webpack_require__(37)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 280 */
279,
/* 281 */
279,
/* 282 */
279,
/* 283 */
279,
/* 284 */
279,
/* 285 */
279,
/* 286 */
279,
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! loadJS: load a JS file asynchronously. [c]2014 @scottjehl, Filament Group, Inc. (Based on http://goo.gl/REQGQ by Paul Irish). Licensed MIT */
	(function( w ){
		var loadJS = function( src, cb ){
			"use strict";
			var ref = w.document.getElementsByTagName( "script" )[ 0 ];
			var script = w.document.createElement( "script" );
			script.src = src;
			script.async = true;
			ref.parentNode.insertBefore( script, ref );
			if (cb && typeof(cb) === "function") {
				script.onload = cb;
			}
			return script;
		};
		// commonjs
		if( true ){
			module.exports = loadJS;
		}
		else {
			w.loadJS = loadJS;
		}
	}( typeof global !== "undefined" ? global : this ));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cartier-logo-white.min.svg";

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cartier-logo.min.svg";

/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (hex) {
		if (typeof hex !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		hex = hex.replace(/^#/, '');
	
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}
	
		var num = parseInt(hex, 16);
	
		return [num >> 16, num >> 8 & 255, num & 255];
	};


/***/ },
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ function(module, exports) {

	module.exports = {
		"photoData": [
			{
				"isGrayscale": false,
				"colors": [
					"#76b4ec",
					"#2b3e59"
				],
				"title": "Sentinel.",
				"date": "2016-02-26T02:01:23.000Z",
				"tags": [
					"architecture",
					"dusk",
					"trees"
				],
				"slug": "sentinel",
				"location": {
					"coordinates": [
						37.779671666666665,
						-122.417375
					],
					"name": "Civic Center, San Francisco, California, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KSFO",
					"time": "2016-04-27T01:56:14.471Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 10,
						"gust": null,
						"direction": 290,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 900,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 3600,
							"cumulonimbus": false
						},
						{
							"abbreviation": "OVC",
							"meaning": "overcast",
							"altitude": 5500,
							"cumulonimbus": false
						}
					],
					"temperature": 16,
					"dewpoint": 12,
					"altimeter_in_hg": 30.15
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#ebd7c6",
					"#8a3b1c"
				],
				"title": "Lower Manhattan from Jersey shore.",
				"date": "2016-02-07T08:00:02.000Z",
				"tags": [
					"architecture",
					"lighthouse",
					"skyline"
				],
				"slug": "lower-manhattan-from-jersey-shore",
				"location": {
					"coordinates": [
						40.72766666666667,
						-74.03061166666667
					],
					"name": "Newport Harbor, Jersey City, New Jersey, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KNYC",
					"time": "2016-04-07T04:51:02.143Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 9,
						"gust": 17,
						"direction": 240,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 3,
					"dewpoint": -6,
					"altimeter_in_hg": 30.28
				},
				"dimensions": [
					2160,
					1440
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#ececec",
					"#0c0c0c"
				],
				"title": "En route.",
				"date": "2016-02-06T21:35:51.000Z",
				"tags": [
					"girl",
					"heels",
					"subway"
				],
				"slug": "en-route",
				"location": {
					"coordinates": [
						40.75463833333333,
						-73.98407
					],
					"name": "Pennsylvania Station, New York, New York, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KNYC",
					"time": "2016-04-06T18:51:51.870Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 5,
						"gust": null,
						"direction": "VRB",
						"variation": true,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 3,
					"dewpoint": -8,
					"altimeter_in_hg": 30.34
				},
				"dimensions": [
					1440,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#e9ab8d",
					"#72271c"
				],
				"title": "Sunset on the Quiet Green.",
				"date": "2016-02-06T01:05:40.000Z",
				"tags": [
					"dusk",
					"school campus",
					"snow"
				],
				"slug": "sunset-on-the-quiet-green",
				"location": {
					"coordinates": [
						41.82672166666667,
						-71.40463833333334
					],
					"name": "Quiet Green, Providence, Rhode Island, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KPVD",
					"time": "2016-04-05T21:51:28.371Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 6,
						"gust": null,
						"direction": 310,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 3100,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 4600,
							"cumulonimbus": false
						}
					],
					"temperature": -1,
					"dewpoint": -3,
					"altimeter_in_hg": 30.05
				},
				"dimensions": [
					2330,
					1440
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#acacac",
					"#343434"
				],
				"title": "Good luck exploring the infinite abyss. II",
				"date": "2015-12-20T22:22:40.000Z",
				"tags": [
					"architecture",
					"concrete",
					"girl"
				],
				"slug": "good-luck-exploring-the-infinite-abyss-ii",
				"location": {
					"coordinates": [
						9.933521666666667,
						-84.07664666666666
					],
					"name": "Museos del Banco Central, San Jos�, Costa Rica"
				},
				"weather": {
					"type": "METAR",
					"station": "MROC",
					"time": "2016-04-20T20:00:58.705Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 14,
						"gust": 27,
						"direction": 70,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": [
						{
							"abbreviation": "-",
							"meaning": "light intensity"
						},
						{
							"abbreviation": "RA",
							"meaning": "rain"
						}
					],
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 3500,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 10000,
							"cumulonimbus": false
						}
					],
					"temperature": 24,
					"dewpoint": 16,
					"altimeter_in_hg": 29.95
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#c1a877",
					"#781d17"
				],
				"title": "Lost in translation.",
				"date": "2015-11-29T03:02:06.000Z",
				"tags": [
					"christmas",
					"culture",
					"shop"
				],
				"slug": "lost-in-translation",
				"location": {
					"coordinates": [
						31.227625,
						121.49056666666667
					],
					"name": "Yu Garden Bazaar, Shanghai, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZSSS",
					"time": "2016-04-28T11:00:01.018Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 3,
						"gust": null,
						"direction": 160,
						"variation": null,
						"unit": "MPS"
					},
					"cavok": true,
					"visibility": null,
					"weather": null,
					"clouds": null,
					"temperature": 12,
					"dewpoint": 4,
					"altimeter_hpa": 1028
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#a6b2e0",
					"#063065"
				],
				"title": "Lujiazui from the Bund.",
				"date": "2015-11-29T01:19:35.000Z",
				"tags": [
					"architecture",
					"river",
					"skyline"
				],
				"slug": "lujiazui-from-the-bund",
				"location": {
					"coordinates": [
						31.236776666666668,
						121.48700333333333
					],
					"name": "Lujiazui, Shanghai, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZSSS",
					"time": "2016-04-28T09:30:03.611Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 2,
						"gust": null,
						"direction": 170,
						"variation": null,
						"unit": "MPS"
					},
					"cavok": true,
					"visibility": null,
					"weather": null,
					"clouds": null,
					"temperature": 12,
					"dewpoint": 3,
					"altimeter_hpa": 1027
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#b4b4b4",
					"#3c3c3c"
				],
				"title": "Expanded horizons.",
				"date": "2015-11-21T20:59:41.000Z",
				"tags": [
					"airport",
					"architecture",
					"parametric design"
				],
				"slug": "expanded-horizons",
				"location": {
					"coordinates": [
						22.628895,
						113.80733333333333
					],
					"name": "Shenzhen Bao'an International Airport, Shenzhen, Guangdong, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZGSZ",
					"time": "2016-04-21T05:00:54.645Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 3,
						"gust": null,
						"direction": 60,
						"variation": {
							"min": 20,
							"max": 100
						},
						"unit": "MPS"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 3300,
							"cumulonimbus": false
						}
					],
					"temperature": 28,
					"dewpoint": 19,
					"altimeter_hpa": 1016
				},
				"dimensions": [
					2330,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#c0dae7",
					"#2a4066"
				],
				"title": "Skyline football.",
				"date": "2015-11-19T04:17:25.000Z",
				"tags": [
					"football",
					"park",
					"skyline"
				],
				"slug": "skyline-football",
				"location": {
					"coordinates": [
						22.282228333333332,
						114.19064166666666
					],
					"name": "Victoria Park, Hong Kong, Hong Kong Island, China"
				},
				"weather": {
					"type": "METAR",
					"station": "VHHH",
					"time": "2016-04-18T12:30:20.411Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 6,
						"gust": null,
						"direction": 70,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2500,
							"cumulonimbus": false
						}
					],
					"temperature": 27,
					"dewpoint": 21,
					"altimeter_hpa": 1016
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#aad2ec",
					"#1a464f"
				],
				"title": "Still, forward.",
				"date": "2015-11-19T01:53:15.000Z",
				"tags": [
					"architecture",
					"office worker",
					"old and new"
				],
				"slug": "still-forward",
				"location": {
					"coordinates": [
						22.28703666666667,
						114.21192833333333
					],
					"name": "Taikoo Place, Hong Kong, Hong Kong Island, China"
				},
				"weather": {
					"type": "METAR",
					"station": "VHHH",
					"time": "2016-04-18T10:00:24.849Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 3,
						"gust": null,
						"direction": 50,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2500,
							"cumulonimbus": false
						}
					],
					"temperature": 28,
					"dewpoint": 23,
					"altimeter_hpa": 1015
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#a6bed9",
					"#08447c"
				],
				"title": "Victoria Harbour at dawn.",
				"date": "2015-11-17T16:11:37.000Z",
				"tags": [
					"harbour",
					"skyline",
					"sunrise"
				],
				"slug": "victoria-harbour-at-dawn",
				"location": {
					"coordinates": [
						22.28138333333333,
						114.17364500000001
					],
					"name": "Renaissance Hong Kong Harbour View Hotel, Hong Kong, Hong Kong Island, China"
				},
				"weather": {
					"type": "METAR",
					"station": "VHHH",
					"time": "2016-04-17T00:00:43.543Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 12,
						"gust": null,
						"direction": 100,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 1200,
							"cumulonimbus": false
						}
					],
					"temperature": 26,
					"dewpoint": 23,
					"altimeter_hpa": 1014
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#bbbbbb",
					"#474747"
				],
				"title": "Night stroll.",
				"date": "2015-11-17T03:40:20.000Z",
				"tags": [
					"night",
					"pier",
					"shadow"
				],
				"slug": "night-stroll",
				"location": {
					"coordinates": [
						22.217499999999998,
						114.21000000000001
					],
					"name": "Blake Pier at Stanley, Hong Kong, Hong Kong Island, China"
				},
				"weather": {
					"type": "METAR",
					"station": "VHHH",
					"time": "2016-04-16T11:30:05.726Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 10,
						"gust": null,
						"direction": 120,
						"variation": {
							"min": 100,
							"max": 160
						},
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 1800,
							"cumulonimbus": false
						}
					],
					"temperature": 27,
					"dewpoint": 22,
					"altimeter_hpa": 1012
				},
				"dimensions": [
					863,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#fcf4f4",
					"#1c5a6b"
				],
				"title": "Seaside outing.",
				"date": "2015-11-16T02:19:23.000Z",
				"tags": [
					"family",
					"ocean",
					"rocks"
				],
				"slug": "seaside-outing",
				"location": {
					"coordinates": [
						22.27457,
						114.116655
					],
					"name": "Mt. Davis, Hong Kong, Hong Kong Island, China"
				},
				"weather": {
					"type": "METAR",
					"station": "VHHH",
					"time": "2016-04-15T10:30:13.257Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 19,
						"gust": null,
						"direction": 110,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 1500,
							"cumulonimbus": false
						},
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 2500,
							"cumulonimbus": false
						}
					],
					"temperature": 26,
					"dewpoint": 21,
					"altimeter_hpa": 1014
				},
				"dimensions": [
					2330,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#f7eacf",
					"#4f4722"
				],
				"title": "Eye of Providence.",
				"date": "2015-08-22T22:18:39.000Z",
				"tags": [
					"eye",
					"government",
					"interior design"
				],
				"slug": "eye-of-providence",
				"location": {
					"coordinates": [
						19.432503333333333,
						-99.13123333333333
					],
					"name": "National Palace, Mexico City, Mexico"
				},
				"weather": {
					"type": "METAR",
					"station": "MMMX",
					"time": "2016-04-22T20:45:55.683Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 12,
						"gust": null,
						"direction": 110,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 8,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 2500,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 10000,
							"cumulonimbus": false
						}
					],
					"temperature": 23,
					"dewpoint": 9,
					"altimeter_in_hg": 30.25
				},
				"dimensions": [
					2160,
					1440
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#d3d3d3",
					"#555555"
				],
				"title": "Triumph.",
				"date": "2015-08-22T06:11:23.000Z",
				"tags": [
					"arch",
					"architecture",
					"plaza"
				],
				"slug": "triumph",
				"location": {
					"coordinates": [
						19.436058333333335,
						-99.15382500000001
					],
					"name": "Monument to the Revolution, Mexico City, D.F., Mexico"
				},
				"weather": {
					"type": "METAR",
					"station": "MMMX",
					"time": "2016-04-22T03:47:41.422Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 3,
						"gust": null,
						"direction": 70,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 8,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "OVC",
							"meaning": "overcast",
							"altitude": 8000,
							"cumulonimbus": false
						}
					],
					"temperature": 16,
					"dewpoint": 12,
					"altimeter_in_hg": 30.36
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#d3bda0",
					"#27445e"
				],
				"title": "Frida's devices.",
				"date": "2015-08-21T21:24:19.000Z",
				"tags": [
					"art supplies",
					"artist",
					"museum"
				],
				"slug": "fridas-devices",
				"location": {
					"coordinates": [
						19.35529166666667,
						-99.16251166666667
					],
					"name": "Frida Kahlo Museum, Mexico City, Mexico"
				},
				"weather": {
					"type": "SPECI",
					"station": "MMMX",
					"time": "2016-04-21T19:43:57.835Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 8,
						"gust": null,
						"direction": 240,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 4,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 2000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "OVC",
							"meaning": "overcast",
							"altitude": 8000,
							"cumulonimbus": false
						}
					],
					"temperature": 21,
					"dewpoint": 7,
					"altimeter_in_hg": 30.29
				},
				"dimensions": [
					2160,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#c9a286",
					"#5b3606"
				],
				"title": "Browse.",
				"date": "2015-08-20T04:05:28.000Z",
				"tags": [
					"books",
					"bookstore",
					"girl"
				],
				"slug": "browse",
				"location": {
					"coordinates": [
						19.418245000000002,
						-99.15875333333334
					],
					"name": "Cafebrer�a El P�ndulo, Mexico City, Mexico"
				},
				"weather": {
					"type": "SPECI",
					"station": "MMMX",
					"time": "2016-04-20T02:18:51.140Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 3,
						"gust": null,
						"direction": 60,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 2000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 8000,
							"cumulonimbus": false
						}
					],
					"temperature": 18,
					"dewpoint": 12,
					"altimeter_in_hg": 30.32
				},
				"dimensions": [
					2160,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#e2d2a2",
					"#674a08"
				],
				"title": "Risen.",
				"date": "2015-08-18T23:03:14.000Z",
				"tags": [
					"interior design",
					"lighting",
					"space"
				],
				"slug": "risen",
				"location": {
					"coordinates": [
						19.425696666666667,
						-99.18176333333334
					],
					"name": "Museum of Modern Art, Mexico City, Mexico"
				},
				"weather": {
					"type": "METAR",
					"station": "MMMX",
					"time": "2016-04-18T20:44:10.379Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 9,
						"gust": null,
						"direction": 310,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 7,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 2000,
							"cumulonimbus": true
						},
						{
							"abbreviation": "OVC",
							"meaning": "overcast",
							"altitude": 8000,
							"cumulonimbus": false
						}
					],
					"temperature": 18,
					"dewpoint": 12,
					"altimeter_in_hg": 30.28
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#bebce0",
					"#213262"
				],
				"title": "Sharks.",
				"date": "2015-08-16T02:51:20.000Z",
				"tags": [
					"quadrangle",
					"school campus",
					"sculpture"
				],
				"slug": "sharks",
				"location": {
					"coordinates": [
						37.424366666666664,
						-122.16791333333333
					],
					"name": "Stanford Law School, Stanford, California, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KNUQ",
					"time": "2016-04-16T02:56:16.280Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 6,
						"gust": null,
						"direction": 350,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 3,
					"weather": [
						{
							"abbreviation": "HZ",
							"meaning": "haze"
						}
					],
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 24,
					"dewpoint": 16,
					"altimeter_in_hg": 29.89
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#f9f0e4",
					"#83512d"
				],
				"title": "Nexus.",
				"date": "2015-08-16T02:02:26.000Z",
				"tags": [
					"architecture",
					"campus",
					"dusk"
				],
				"slug": "nexus",
				"location": {
					"coordinates": [
						37.430924999999995,
						-122.17366166666667
					],
					"name": "James H. Clark Center, Stanford, California, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KNUQ",
					"time": "2016-04-16T01:56:05.254Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 11,
						"gust": null,
						"direction": 350,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 8,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 27,
					"dewpoint": 17,
					"altimeter_in_hg": 29.88
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#f1f1f1",
					"#383838"
				],
				"title": "Ascend.",
				"date": "2015-07-16T23:46:23.000Z",
				"tags": [
					"lighthouse",
					"stairs",
					"window"
				],
				"slug": "ascend",
				"location": {
					"coordinates": [
						29.885424999999998,
						-81.28853333333333
					],
					"name": "St. Augustine Lighthouse, St. Augustine, Florida, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KSGJ",
					"time": "2016-04-16T20:58:50.322Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 6,
						"gust": null,
						"direction": 240,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 7500,
							"cumulonimbus": false
						},
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 9000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "OVC",
							"meaning": "overcast",
							"altitude": 11000,
							"cumulonimbus": false
						}
					],
					"temperature": 31,
					"dewpoint": 23,
					"altimeter_in_hg": 29.95
				},
				"dimensions": [
					960,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#f0e2c5",
					"#274b63"
				],
				"title": "Refuel.",
				"date": "2015-07-15T22:48:53.000Z",
				"tags": [
					"coffee shop",
					"furniture",
					"interior design"
				],
				"slug": "refuel",
				"location": {
					"coordinates": [
						44.93540333333333,
						-93.63243333333332
					],
					"name": "Spring Park Coffee, Green Cove Springs, Florida, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "K42J",
					"time": "2016-04-15T19:55:09.353Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 5,
						"gust": null,
						"direction": 250,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 4900,
							"cumulonimbus": false
						},
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 10000,
							"cumulonimbus": false
						}
					],
					"temperature": 28,
					"dewpoint": 23,
					"altimeter_in_hg": 29.95
				},
				"dimensions": [
					2330,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#dfe6f0",
					"#4a3314"
				],
				"title": "Sanctuary.",
				"date": "2015-07-14T20:53:20.000Z",
				"tags": [
					"architecture",
					"meditation",
					"nature"
				],
				"slug": "sanctuary",
				"location": {
					"coordinates": [
						29.64200333333333,
						-82.363675
					],
					"name": "Baughman Center, Gainesville, Florida, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KGNV",
					"time": "2016-04-14T14:53:10.998Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 7,
						"gust": null,
						"direction": 260,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2300,
							"cumulonimbus": false
						},
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 2900,
							"cumulonimbus": false
						}
					],
					"temperature": 31,
					"dewpoint": 24,
					"altimeter_in_hg": 29.95
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#dde6f4",
					"#21335c"
				],
				"title": "Sink in.",
				"date": "2015-07-13T17:19:04.000Z",
				"tags": [
					"architecture",
					"school campus",
					"sculpture"
				],
				"slug": "sink-in",
				"location": {
					"coordinates": [
						29.64775,
						-82.34456333333333
					],
					"name": "Marston Science Library, Gainesville, Florida, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KGNV",
					"time": "2016-04-13T13:53:18.183Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 3,
						"gust": null,
						"direction": "VRB",
						"variation": true,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 27,
					"dewpoint": 24,
					"altimeter_in_hg": 29.98
				},
				"dimensions": [
					948,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#c1c6e6",
					"#5e3722"
				],
				"title": "Peak.",
				"date": "2015-07-04T20:14:00.000Z",
				"tags": [
					"canyon",
					"landscape",
					"mountain"
				],
				"slug": "peak",
				"location": {
					"coordinates": [
						37.261075,
						-112.95584666666667
					],
					"name": "Great White Throne, Hurricane, Utah, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KAZC",
					"time": "2016-04-04T20:15:06.668Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 8,
						"gust": 14,
						"direction": 250,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": [
						{
							"abbreviation": "VC",
							"meaning": "in the vicinity"
						},
						{
							"abbreviation": "TS",
							"meaning": "thunderstorm"
						}
					],
					"clouds": [
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 6000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 9000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 11000,
							"cumulonimbus": false
						}
					],
					"temperature": 29,
					"dewpoint": 11,
					"altimeter_in_hg": 30.11
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#cbdaed",
					"#525122"
				],
				"title": "Start of a revolution.",
				"date": "2015-04-14T17:40:51.000Z",
				"tags": [
					"architecture",
					"museum",
					"plaza"
				],
				"slug": "start-of-a-revolution",
				"location": {
					"coordinates": [
						30.54726666666667,
						114.29692
					],
					"name": "1911 Revolution Museum (from top of Yellow Crane Tower), Wuhan, Hubei, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZHHH",
					"time": "2016-04-14T03:00:23.581Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 5,
						"gust": null,
						"direction": 240,
						"variation": {
							"min": 220,
							"max": 280
						},
						"unit": "MPS"
					},
					"cavok": true,
					"visibility": null,
					"weather": null,
					"clouds": null,
					"temperature": 18,
					"dewpoint": 3,
					"altimeter_hpa": 1020
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#ecdbac",
					"#9c3618"
				],
				"title": "Enlightenment.",
				"date": "2015-04-13T19:46:30.000Z",
				"tags": [
					"buddha",
					"temple",
					"throne"
				],
				"slug": "enlightenment",
				"location": {
					"coordinates": [
						13.751238333333333,
						100.49283
					],
					"name": "Wat Phra Kaew (Temple of the Emerald Buddha), Bangkok, Thailand"
				},
				"weather": {
					"type": "METAR",
					"station": "VTBD",
					"time": "2016-04-13T06:00:53.036Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 5,
						"gust": null,
						"direction": 90,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 3000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 30000,
							"cumulonimbus": false
						}
					],
					"temperature": 33,
					"dewpoint": 21,
					"altimeter_hpa": 1014
				},
				"dimensions": [
					2511,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#e0e1df",
					"#5a4229"
				],
				"title": "Form.",
				"date": "2015-04-12T01:18:32.000Z",
				"tags": [
					"boxing ring",
					"muay thai",
					"stadium"
				],
				"slug": "form",
				"location": {
					"coordinates": [
						13.867245,
						100.60886333333333
					],
					"name": "Lumpinee Boxing Stadium, Bangkok, Thailand"
				},
				"weather": {
					"type": "METAR",
					"station": "VTBD",
					"time": "2016-04-11T11:00:56.448Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 9,
						"gust": null,
						"direction": 130,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "SCT",
							"meaning": "scattered",
							"altitude": 12000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 30000,
							"cumulonimbus": false
						}
					],
					"temperature": 30,
					"dewpoint": 22,
					"altimeter_hpa": 1009
				},
				"dimensions": [
					2160,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#d3dff3",
					"#08607d"
				],
				"title": "The rock.",
				"date": "2015-04-09T19:51:29.000Z",
				"tags": [
					"island",
					"ocean",
					"rocks"
				],
				"slug": "the-rock",
				"location": {
					"coordinates": [
						8.592595000000001,
						97.63977000000001
					],
					"name": "Mu Ko Similan National Park, Phang Nga, Thailand"
				},
				"weather": {
					"type": "METAR",
					"station": "VTSP",
					"time": "2016-04-09T06:00:34.702Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 8,
						"gust": null,
						"direction": 70,
						"variation": {
							"min": 20,
							"max": 130
						},
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2200,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 30000,
							"cumulonimbus": false
						}
					],
					"temperature": 34,
					"dewpoint": 16,
					"altimeter_hpa": 1011
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#ba8364",
					"#321d18"
				],
				"title": "Point.",
				"date": "2015-04-08T17:14:19.000Z",
				"tags": [
					"island",
					"lines",
					"rocks"
				],
				"slug": "point",
				"location": {
					"coordinates": [
						8.275421666666668,
						98.50051666666667
					],
					"name": "Khao Phing Kan (James Bond Island), Phang Nga, Thailand"
				},
				"weather": {
					"type": "METAR",
					"station": "VTSP",
					"time": "2016-04-08T03:30:07.549Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 8,
						"gust": null,
						"direction": 90,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 8000,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 30000,
							"cumulonimbus": false
						}
					],
					"temperature": 31,
					"dewpoint": 21,
					"altimeter_hpa": 1011
				},
				"dimensions": [
					799,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#b1aadf",
					"#1c421d"
				],
				"title": "Andaman shore.",
				"date": "2015-04-08T16:10:34.000Z",
				"tags": [
					"boating",
					"ocean",
					"trees"
				],
				"slug": "andaman-shore",
				"location": {
					"coordinates": [
						8.300508333333335,
						98.45563
					],
					"name": "Ao Phang Nga National Park, Phang Nga, Thailand"
				},
				"weather": {
					"type": "METAR",
					"station": "VTSP",
					"time": "2016-04-08T01:00:49.891Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 6,
						"gust": null,
						"direction": 100,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 8000,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 2000,
							"cumulonimbus": false
						},
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 30000,
							"cumulonimbus": false
						}
					],
					"temperature": 28,
					"dewpoint": 24,
					"altimeter_hpa": 1011
				},
				"dimensions": [
					2221,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#d0a684",
					"#571e20"
				],
				"title": "Shredding rainbow.",
				"date": "2015-01-17T19:51:00.000Z",
				"tags": [
					"backpack",
					"forest",
					"snowboarding"
				],
				"slug": "shredding-rainbow",
				"location": {
					"coordinates": [
						39.46415833333334,
						-106.055145
					],
					"name": "Breckenridge Ski Resort, Breckenridge, Colorado, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KCCU",
					"time": "2016-04-17T18:55:17.497Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 20,
						"gust": 27,
						"direction": 260,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": null,
					"weather": null,
					"clouds": null,
					"temperature": -6,
					"dewpoint": -19,
					"altimeter_in_hg": 30.34
				},
				"dimensions": [
					1080,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#cde1fb",
					"#122269"
				],
				"title": "Haleakalā.",
				"date": "2014-12-28T21:00:15.000Z",
				"tags": [
					"island",
					"mountain",
					"volcano"
				],
				"slug": "haleakala",
				"location": {
					"coordinates": [
						20.715094999999998,
						-156.24967166666664
					],
					"name": "Haleakal?, Kula, Hawaii, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "PHKO",
					"time": "2016-04-28T22:53:59.512Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 9,
						"gust": null,
						"direction": 330,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 5000,
							"cumulonimbus": false
						}
					],
					"temperature": 27,
					"dewpoint": 15,
					"altimeter_in_hg": 29.88
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#d5d5d5",
					"#4f4f4f"
				],
				"title": "Snapshot.",
				"date": "2014-09-06T23:58:41.000Z",
				"tags": [
					"architecture",
					"concrete",
					"street"
				],
				"slug": "snapshot",
				"location": {
					"coordinates": [
						31.254633333333334,
						121.49212833333334
					],
					"name": "1933??? (1933 Shanghai), Shanghai, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZSSS",
					"time": "2016-04-06T09:00:21.168Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 5,
						"gust": null,
						"direction": 60,
						"variation": {
							"min": 30,
							"max": 90
						},
						"unit": "MPS"
					},
					"cavok": true,
					"visibility": null,
					"weather": null,
					"clouds": null,
					"temperature": 29,
					"dewpoint": 21,
					"altimeter_hpa": 1009
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#be8771",
					"#1c130c"
				],
				"title": "The graduate.",
				"date": "2013-05-19T23:57:45.000Z",
				"tags": [
					"graduation",
					"school campus",
					"student"
				],
				"slug": "the-graduate",
				"location": {
					"coordinates": [
						37.873446666666666,
						-122.25401333333333
					],
					"name": "Greek Theatre, Berkeley, California, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KOAK",
					"time": "2016-04-19T23:53:32.516Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 10,
						"gust": null,
						"direction": 290,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 22,
					"dewpoint": 10,
					"altimeter_in_hg": 30.03
				},
				"dimensions": [
					2330,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#dcc6a5",
					"#664806"
				],
				"title": "The sun and the moon.",
				"date": "2012-12-18T23:22:51.000Z",
				"tags": [
					"architecture",
					"fall",
					"pagoda"
				],
				"slug": "the-sun-and-the-moon",
				"location": {
					"coordinates": [
						25.275683333333333,
						110.28951166666667
					],
					"name": "???? (Sun & Moon Twin Pagodas Cultural Park), Guilin, Guangxi, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZGKL",
					"time": "2016-04-18T07:00:36.669Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 7,
						"gust": null,
						"direction": 60,
						"variation": {
							"min": 30,
							"max": 90
						},
						"unit": "MPS"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 4600,
							"cumulonimbus": false
						}
					],
					"temperature": 10,
					"dewpoint": 4,
					"altimeter_hpa": 1028
				},
				"dimensions": [
					2052,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#4cbcd9",
					"#192c60"
				],
				"title": "Neon ballroom.",
				"date": "2012-12-12T20:05:23.000Z",
				"tags": [
					"airport",
					"lighting",
					"moving walkway"
				],
				"slug": "neon-ballroom",
				"location": {
					"coordinates": [
						41.97553666666667,
						-87.90321166666668
					],
					"name": "Chicago O'Hare International Airport, Chicago, Illinois, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KORD",
					"time": "2016-04-12T16:51:04.594Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 13,
						"gust": null,
						"direction": 210,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "FEW",
							"meaning": "few",
							"altitude": 25000,
							"cumulonimbus": false
						}
					],
					"temperature": 5,
					"dewpoint": -5,
					"altimeter_in_hg": 30.27
				},
				"dimensions": [
					2330,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#dd9d59",
					"#3d1f0f"
				],
				"title": "Through the gates of hell.",
				"date": "2012-11-19T04:16:16.000Z",
				"tags": [
					"gas flare",
					"night",
					"oil field"
				],
				"slug": "through-the-gates-of-hell",
				"location": {
					"coordinates": [
						48.210588333333334,
						-102.66410333333334
					],
					"name": "An oil field, Bakken formation, North Dakota, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "K08D",
					"time": "2016-04-19T02:15:40.551Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 8,
						"gust": null,
						"direction": 290,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 11000,
							"cumulonimbus": false
						}
					],
					"temperature": 3,
					"dewpoint": 2,
					"altimeter_in_hg": 29.85
				},
				"dimensions": [
					2560,
					1071
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#dad8d7",
					"#ab220a"
				],
				"title": "The warmth in my vein.",
				"date": "2012-10-08T02:16:34.000Z",
				"tags": [
					"architecture",
					"metropolitan",
					"skyline"
				],
				"slug": "the-warmth-in-my-vein",
				"location": {
					"coordinates": [
						44.95909666666667,
						-93.26956166666666
					],
					"name": "Minneapolis, Minnesota, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KMIC",
					"time": "2016-04-07T23:53:38.762Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 4,
						"gust": null,
						"direction": 160,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 9,
					"dewpoint": -9,
					"altimeter_in_hg": 29.92
				},
				"dimensions": [
					2560,
					1401
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#b0bfd4",
					"#484848"
				],
				"title": "Our omnipotent overlord.",
				"date": "2012-09-17T01:41:19.000Z",
				"tags": [
					"architecture",
					"concrete",
					"window"
				],
				"slug": "our-omnipotent-overlord",
				"location": {
					"coordinates": [
						44.9715,
						-93.215
					],
					"name": "University Park Plaza, Minneapolis, Minnesota, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KMIC",
					"time": "2016-04-16T23:53:06.333Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 5,
						"gust": null,
						"direction": 340,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "CLR",
							"meaning": "no clouds under 12,000 ft",
							"altitude": null,
							"cumulonimbus": false
						}
					],
					"temperature": 23,
					"dewpoint": 9,
					"altimeter_in_hg": 29.88
				},
				"dimensions": [
					1223,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#99b8d2",
					"#04171b"
				],
				"title": "Lake Yellowstone Hotel.",
				"date": "2012-08-10T21:12:20.000Z",
				"tags": [
					"hotel",
					"lake",
					"national park"
				],
				"slug": "lake-yellowstone-hotel",
				"location": {
					"coordinates": [
						44.56556666666666,
						-110.418525
					],
					"name": "Elephant Back Mountain, Yellowstone National Park, Wyoming, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KP60",
					"time": "2016-04-10T19:56:00.609Z",
					"auto": true,
					"correction": false,
					"wind": {
						"speed": 0,
						"gust": null,
						"direction": 0,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 19,
					"weather": null,
					"clouds": null
				},
				"dimensions": [
					890,
					1440
				]
			},
			{
				"isGrayscale": true,
				"colors": [
					"#f4f4f4",
					"#5c5c5c"
				],
				"title": "The fallen.",
				"date": "2012-06-15T17:36:27.000Z",
				"tags": [
					"architecture",
					"concrete",
					"monument",
					"scouting"
				],
				"slug": "the-fallen",
				"location": {
					"coordinates": [
						31.244333333333334,
						121.48683333333334
					],
					"name": "Monument to the People's Heroes, Shanghai, China"
				},
				"weather": {
					"type": "METAR",
					"station": "ZSSS",
					"time": "2016-04-15T02:30:29.858Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 4,
						"gust": null,
						"direction": 80,
						"variation": null,
						"unit": "MPS"
					},
					"cavok": false,
					"visibility": 9999,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "BKN",
							"meaning": "broken",
							"altitude": 1600,
							"cumulonimbus": false
						}
					],
					"temperature": 26,
					"dewpoint": 22,
					"altimeter_hpa": 1005
				},
				"dimensions": [
					1149,
					1440
				]
			},
			{
				"isGrayscale": false,
				"colors": [
					"#e7ad90",
					"#4b241e"
				],
				"title": "Joshua Ryan Miller.",
				"date": "2009-12-04T23:39:50.000Z",
				"tags": [
					"guitar",
					"musician",
					"recording studio"
				],
				"slug": "joshua-ryan-miller",
				"location": {
					"coordinates": [
						45.37788833333333,
						-94.01636666666667
					],
					"name": "Stirling Sound, Clearwater, Minnesota, United States"
				},
				"weather": {
					"type": "METAR",
					"station": "KSTC",
					"time": "2016-04-04T21:53:00.212Z",
					"auto": false,
					"correction": false,
					"wind": {
						"speed": 9,
						"gust": null,
						"direction": 220,
						"variation": null,
						"unit": "KT"
					},
					"cavok": false,
					"visibility": 10,
					"weather": null,
					"clouds": [
						{
							"abbreviation": "OVC",
							"meaning": "overcast",
							"altitude": 1700,
							"cumulonimbus": false
						}
					],
					"temperature": -7,
					"dewpoint": -12,
					"altimeter_in_hg": 29.94
				},
				"dimensions": [
					960,
					1440
				]
			}
		]
	};

/***/ },
/* 309 */
/***/ function(module, exports) {

	module.exports = {
		"grid-gutter": "64px",
		"animation-delay-factor": "2",
		"c-detail-main-picture-build-duration": "500ms",
		"c-detail-main-accessory-build-duration": "250ms",
		"c-detail-info-item-build-duration": "250ms",
		"cDetailMainBuildOut": "$c-detail-main-accessory-build-duration / $animation-delay-factor + $c-detail-main-picture-build-duration",
		"cDetailInfoBuildOut": "$c-detail-info-item-build-duration * ((1 / $animation-delay-factor) * 2 + 1)",
		"cDetailMainLeave": 625,
		"cDetailInfoLeave": 500,
		"cDetailMainBuildInInitial": "$c-detail-main-picture-build-duration / $animation-delay-factor + $c-detail-main-accessory-build-duration",
		"cDetailInfoBuildInInitial": "$c-detail-info-item-build-duration * ((1 / $animation-delay-factor) * 2 + 1)",
		"cDetailMainAppear": 500,
		"cDetailInfoAppear": 500,
		"cDetailMainBuildInSubsequent": "$cDetailInfoBuildOut + $cDetailMainBuildInInitial",
		"cDetailInfoBuildInSubsequent": "($cDetailMainBuildOut / $animation-delay-factor) + $cDetailInfoBuildInInitial",
		"cDetailMainEnter": 1000,
		"cDetailInfoEnter": 813
	};

/***/ },
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(23);
	
	var ReactTransitionGroup = __webpack_require__(411);
	var ReactCSSTransitionGroupChild = __webpack_require__(402);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: React.PropTypes.bool,
	  transitionEnter: React.PropTypes.bool,
	  transitionLeave: React.PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(23);
	var ReactAddonsDOMDependencies = __webpack_require__(183);
	
	var CSSCore = __webpack_require__(287);
	var ReactTransitionEvents = __webpack_require__(410);
	
	var onlyChild = __webpack_require__(188);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(413);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getVendorPrefixedEventName = __webpack_require__(169);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(23);
	var ReactAddonsDOMDependencies = __webpack_require__(183);
	var ReactTransitionChildMapping = __webpack_require__(409);
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: React.PropTypes.any,
	  childFactory: React.PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 412 */,
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(182);
	var traverseAllChildren = __webpack_require__(189);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(116);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ }
]);


// WEBPACK FOOTER //
// bundle-36f38574e911cd45866b.js